const tokens = {
  "blurs.sm": {
    "value": "4px",
    "variable": "var(--blurs-sm)"
  },
  "blurs.base": {
    "value": "8px",
    "variable": "var(--blurs-base)"
  },
  "blurs.md": {
    "value": "12px",
    "variable": "var(--blurs-md)"
  },
  "blurs.lg": {
    "value": "16px",
    "variable": "var(--blurs-lg)"
  },
  "blurs.xl": {
    "value": "24px",
    "variable": "var(--blurs-xl)"
  },
  "blurs.2xl": {
    "value": "40px",
    "variable": "var(--blurs-2xl)"
  },
  "blurs.3xl": {
    "value": "64px",
    "variable": "var(--blurs-3xl)"
  },
  "borders.none": {
    "value": "none",
    "variable": "var(--borders-none)"
  },
  "durations.fastest": {
    "value": "50ms",
    "variable": "var(--durations-fastest)"
  },
  "durations.faster": {
    "value": "100ms",
    "variable": "var(--durations-faster)"
  },
  "durations.fast": {
    "value": "150ms",
    "variable": "var(--durations-fast)"
  },
  "durations.normal": {
    "value": "200ms",
    "variable": "var(--durations-normal)"
  },
  "durations.slow": {
    "value": "300ms",
    "variable": "var(--durations-slow)"
  },
  "durations.slower": {
    "value": "400ms",
    "variable": "var(--durations-slower)"
  },
  "durations.slowest": {
    "value": "500ms",
    "variable": "var(--durations-slowest)"
  },
  "easings.pulse": {
    "value": "cubic-bezier(0.4, 0.0, 0.6, 1.0)",
    "variable": "var(--easings-pulse)"
  },
  "easings.default": {
    "value": "cubic-bezier(0.2, 0.0, 0, 1.0)",
    "variable": "var(--easings-default)"
  },
  "easings.emphasized-in": {
    "value": "cubic-bezier(0.05, 0.7, 0.1, 1.0)",
    "variable": "var(--easings-emphasized-in)"
  },
  "easings.emphasized-out": {
    "value": "cubic-bezier(0.3, 0.0, 0.8, 0.15)",
    "variable": "var(--easings-emphasized-out)"
  },
  "fonts.sans": {
    "value": "ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, \"Noto Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\"",
    "variable": "var(--fonts-sans)"
  },
  "fonts.serif": {
    "value": "ui-serif, Georgia, Cambria, \"Times New Roman\", Times, serif",
    "variable": "var(--fonts-serif)"
  },
  "fonts.mono": {
    "value": "ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace",
    "variable": "var(--fonts-mono)"
  },
  "fontSizes.2xs": {
    "value": "0.5rem",
    "variable": "var(--font-sizes-2xs)"
  },
  "fontSizes.xs": {
    "value": "0.75rem",
    "variable": "var(--font-sizes-xs)"
  },
  "fontSizes.sm": {
    "value": "0.875rem",
    "variable": "var(--font-sizes-sm)"
  },
  "fontSizes.md": {
    "value": "1rem",
    "variable": "var(--font-sizes-md)"
  },
  "fontSizes.lg": {
    "value": "1.125rem",
    "variable": "var(--font-sizes-lg)"
  },
  "fontSizes.xl": {
    "value": "1.25rem",
    "variable": "var(--font-sizes-xl)"
  },
  "fontSizes.2xl": {
    "value": "1.5rem",
    "variable": "var(--font-sizes-2xl)"
  },
  "fontSizes.3xl": {
    "value": "1.875rem",
    "variable": "var(--font-sizes-3xl)"
  },
  "fontSizes.4xl": {
    "value": "2.25rem",
    "variable": "var(--font-sizes-4xl)"
  },
  "fontSizes.5xl": {
    "value": "3rem",
    "variable": "var(--font-sizes-5xl)"
  },
  "fontSizes.6xl": {
    "value": "3.75rem",
    "variable": "var(--font-sizes-6xl)"
  },
  "fontSizes.7xl": {
    "value": "4.5rem",
    "variable": "var(--font-sizes-7xl)"
  },
  "fontSizes.8xl": {
    "value": "6rem",
    "variable": "var(--font-sizes-8xl)"
  },
  "fontSizes.9xl": {
    "value": "8rem",
    "variable": "var(--font-sizes-9xl)"
  },
  "fontWeights.thin": {
    "value": "100",
    "variable": "var(--font-weights-thin)"
  },
  "fontWeights.extralight": {
    "value": "200",
    "variable": "var(--font-weights-extralight)"
  },
  "fontWeights.light": {
    "value": "300",
    "variable": "var(--font-weights-light)"
  },
  "fontWeights.normal": {
    "value": "400",
    "variable": "var(--font-weights-normal)"
  },
  "fontWeights.medium": {
    "value": "500",
    "variable": "var(--font-weights-medium)"
  },
  "fontWeights.semibold": {
    "value": "600",
    "variable": "var(--font-weights-semibold)"
  },
  "fontWeights.bold": {
    "value": "700",
    "variable": "var(--font-weights-bold)"
  },
  "fontWeights.extrabold": {
    "value": "800",
    "variable": "var(--font-weights-extrabold)"
  },
  "fontWeights.black": {
    "value": "900",
    "variable": "var(--font-weights-black)"
  },
  "letterSpacings.tighter": {
    "value": "-0.05em",
    "variable": "var(--letter-spacings-tighter)"
  },
  "letterSpacings.tight": {
    "value": "-0.025em",
    "variable": "var(--letter-spacings-tight)"
  },
  "letterSpacings.normal": {
    "value": "0em",
    "variable": "var(--letter-spacings-normal)"
  },
  "letterSpacings.wide": {
    "value": "0.025em",
    "variable": "var(--letter-spacings-wide)"
  },
  "letterSpacings.wider": {
    "value": "0.05em",
    "variable": "var(--letter-spacings-wider)"
  },
  "letterSpacings.widest": {
    "value": "0.1em",
    "variable": "var(--letter-spacings-widest)"
  },
  "lineHeights.none": {
    "value": "1",
    "variable": "var(--line-heights-none)"
  },
  "lineHeights.tight": {
    "value": "1.25",
    "variable": "var(--line-heights-tight)"
  },
  "lineHeights.normal": {
    "value": "1.5",
    "variable": "var(--line-heights-normal)"
  },
  "lineHeights.relaxed": {
    "value": "1.75",
    "variable": "var(--line-heights-relaxed)"
  },
  "lineHeights.loose": {
    "value": "2",
    "variable": "var(--line-heights-loose)"
  },
  "radii.none": {
    "value": "0",
    "variable": "var(--radii-none)"
  },
  "radii.2xs": {
    "value": "0.0625rem",
    "variable": "var(--radii-2xs)"
  },
  "radii.xs": {
    "value": "0.125rem",
    "variable": "var(--radii-xs)"
  },
  "radii.sm": {
    "value": "0.25rem",
    "variable": "var(--radii-sm)"
  },
  "radii.md": {
    "value": "0.375rem",
    "variable": "var(--radii-md)"
  },
  "radii.lg": {
    "value": "0.5rem",
    "variable": "var(--radii-lg)"
  },
  "radii.xl": {
    "value": "0.75rem",
    "variable": "var(--radii-xl)"
  },
  "radii.2xl": {
    "value": "1rem",
    "variable": "var(--radii-2xl)"
  },
  "radii.3xl": {
    "value": "1.5rem",
    "variable": "var(--radii-3xl)"
  },
  "radii.full": {
    "value": "9999px",
    "variable": "var(--radii-full)"
  },
  "spacing.0": {
    "value": "0rem",
    "variable": "var(--spacing-0)"
  },
  "spacing.1": {
    "value": "0.25rem",
    "variable": "var(--spacing-1)"
  },
  "spacing.2": {
    "value": "0.5rem",
    "variable": "var(--spacing-2)"
  },
  "spacing.3": {
    "value": "0.75rem",
    "variable": "var(--spacing-3)"
  },
  "spacing.4": {
    "value": "1rem",
    "variable": "var(--spacing-4)"
  },
  "spacing.5": {
    "value": "1.25rem",
    "variable": "var(--spacing-5)"
  },
  "spacing.6": {
    "value": "1.5rem",
    "variable": "var(--spacing-6)"
  },
  "spacing.7": {
    "value": "1.75rem",
    "variable": "var(--spacing-7)"
  },
  "spacing.8": {
    "value": "2rem",
    "variable": "var(--spacing-8)"
  },
  "spacing.9": {
    "value": "2.25rem",
    "variable": "var(--spacing-9)"
  },
  "spacing.10": {
    "value": "2.5rem",
    "variable": "var(--spacing-10)"
  },
  "spacing.11": {
    "value": "2.75rem",
    "variable": "var(--spacing-11)"
  },
  "spacing.12": {
    "value": "3rem",
    "variable": "var(--spacing-12)"
  },
  "spacing.14": {
    "value": "3.5rem",
    "variable": "var(--spacing-14)"
  },
  "spacing.16": {
    "value": "4rem",
    "variable": "var(--spacing-16)"
  },
  "spacing.20": {
    "value": "5rem",
    "variable": "var(--spacing-20)"
  },
  "spacing.24": {
    "value": "6rem",
    "variable": "var(--spacing-24)"
  },
  "spacing.28": {
    "value": "7rem",
    "variable": "var(--spacing-28)"
  },
  "spacing.32": {
    "value": "8rem",
    "variable": "var(--spacing-32)"
  },
  "spacing.36": {
    "value": "9rem",
    "variable": "var(--spacing-36)"
  },
  "spacing.40": {
    "value": "10rem",
    "variable": "var(--spacing-40)"
  },
  "spacing.44": {
    "value": "11rem",
    "variable": "var(--spacing-44)"
  },
  "spacing.48": {
    "value": "12rem",
    "variable": "var(--spacing-48)"
  },
  "spacing.52": {
    "value": "13rem",
    "variable": "var(--spacing-52)"
  },
  "spacing.56": {
    "value": "14rem",
    "variable": "var(--spacing-56)"
  },
  "spacing.60": {
    "value": "15rem",
    "variable": "var(--spacing-60)"
  },
  "spacing.64": {
    "value": "16rem",
    "variable": "var(--spacing-64)"
  },
  "spacing.72": {
    "value": "18rem",
    "variable": "var(--spacing-72)"
  },
  "spacing.80": {
    "value": "20rem",
    "variable": "var(--spacing-80)"
  },
  "spacing.96": {
    "value": "24rem",
    "variable": "var(--spacing-96)"
  },
  "spacing.0.5": {
    "value": "0.125rem",
    "variable": "var(--spacing-0\\.5)"
  },
  "spacing.1.5": {
    "value": "0.375rem",
    "variable": "var(--spacing-1\\.5)"
  },
  "spacing.2.5": {
    "value": "0.625rem",
    "variable": "var(--spacing-2\\.5)"
  },
  "spacing.3.5": {
    "value": "0.875rem",
    "variable": "var(--spacing-3\\.5)"
  },
  "spacing.4.5": {
    "value": "1.125rem",
    "variable": "var(--spacing-4\\.5)"
  },
  "zIndex.hide": {
    "value": -1,
    "variable": "var(--z-index-hide)"
  },
  "zIndex.base": {
    "value": 0,
    "variable": "var(--z-index-base)"
  },
  "zIndex.docked": {
    "value": 10,
    "variable": "var(--z-index-docked)"
  },
  "zIndex.dropdown": {
    "value": 1000,
    "variable": "var(--z-index-dropdown)"
  },
  "zIndex.sticky": {
    "value": 1100,
    "variable": "var(--z-index-sticky)"
  },
  "zIndex.banner": {
    "value": 1200,
    "variable": "var(--z-index-banner)"
  },
  "zIndex.overlay": {
    "value": 1300,
    "variable": "var(--z-index-overlay)"
  },
  "zIndex.modal": {
    "value": 1400,
    "variable": "var(--z-index-modal)"
  },
  "zIndex.popover": {
    "value": 1500,
    "variable": "var(--z-index-popover)"
  },
  "zIndex.skipLink": {
    "value": 1600,
    "variable": "var(--z-index-skip-link)"
  },
  "zIndex.toast": {
    "value": 1700,
    "variable": "var(--z-index-toast)"
  },
  "zIndex.tooltip": {
    "value": 1800,
    "variable": "var(--z-index-tooltip)"
  },
  "animations.backdrop-in": {
    "value": "fade-in 250ms var(--easings-emphasized-in)",
    "variable": "var(--animations-backdrop-in)"
  },
  "animations.backdrop-out": {
    "value": "fade-out 200ms var(--easings-emphasized-out)",
    "variable": "var(--animations-backdrop-out)"
  },
  "animations.dialog-in": {
    "value": "slide-in 400ms var(--easings-emphasized-in)",
    "variable": "var(--animations-dialog-in)"
  },
  "animations.dialog-out": {
    "value": "slide-out 200ms var(--easings-emphasized-out)",
    "variable": "var(--animations-dialog-out)"
  },
  "animations.drawer-in-left": {
    "value": "slide-in-left 400ms var(--easings-emphasized-in)",
    "variable": "var(--animations-drawer-in-left)"
  },
  "animations.drawer-out-left": {
    "value": "slide-out-left 200ms var(--easings-emphasized-out)",
    "variable": "var(--animations-drawer-out-left)"
  },
  "animations.drawer-in-right": {
    "value": "slide-in-right 400ms var(--easings-emphasized-in)",
    "variable": "var(--animations-drawer-in-right)"
  },
  "animations.drawer-out-right": {
    "value": "slide-out-right 200ms var(--easings-emphasized-out)",
    "variable": "var(--animations-drawer-out-right)"
  },
  "animations.skeleton-pulse": {
    "value": "skeleton-pulse 2s var(--easings-pulse) infinite",
    "variable": "var(--animations-skeleton-pulse)"
  },
  "animations.fade-in": {
    "value": "fade-in 400ms var(--easings-emphasized-in)",
    "variable": "var(--animations-fade-in)"
  },
  "animations.collapse-in": {
    "value": "collapse-in 250ms var(--easings-emphasized-in)",
    "variable": "var(--animations-collapse-in)"
  },
  "animations.collapse-out": {
    "value": "collapse-out 200ms var(--easings-emphasized-out)",
    "variable": "var(--animations-collapse-out)"
  },
  "animations.spin": {
    "value": "var(--animations-spin)",
    "variable": "var(--animations-spin)"
  },
  "colors.current": {
    "value": "currentColor",
    "variable": "var(--colors-current)"
  },
  "colors.black": {
    "value": "#000000",
    "variable": "var(--colors-black)"
  },
  "colors.black.a1": {
    "value": "rgba(0, 0, 0, 0.05)",
    "variable": "var(--colors-black-a1)"
  },
  "colors.black.a2": {
    "value": "rgba(0, 0, 0, 0.1)",
    "variable": "var(--colors-black-a2)"
  },
  "colors.black.a3": {
    "value": "rgba(0, 0, 0, 0.15)",
    "variable": "var(--colors-black-a3)"
  },
  "colors.black.a4": {
    "value": "rgba(0, 0, 0, 0.2)",
    "variable": "var(--colors-black-a4)"
  },
  "colors.black.a5": {
    "value": "rgba(0, 0, 0, 0.3)",
    "variable": "var(--colors-black-a5)"
  },
  "colors.black.a6": {
    "value": "rgba(0, 0, 0, 0.4)",
    "variable": "var(--colors-black-a6)"
  },
  "colors.black.a7": {
    "value": "rgba(0, 0, 0, 0.5)",
    "variable": "var(--colors-black-a7)"
  },
  "colors.black.a8": {
    "value": "rgba(0, 0, 0, 0.6)",
    "variable": "var(--colors-black-a8)"
  },
  "colors.black.a9": {
    "value": "rgba(0, 0, 0, 0.7)",
    "variable": "var(--colors-black-a9)"
  },
  "colors.black.a10": {
    "value": "rgba(0, 0, 0, 0.8)",
    "variable": "var(--colors-black-a10)"
  },
  "colors.black.a11": {
    "value": "rgba(0, 0, 0, 0.9)",
    "variable": "var(--colors-black-a11)"
  },
  "colors.black.a12": {
    "value": "rgba(0, 0, 0, 0.95)",
    "variable": "var(--colors-black-a12)"
  },
  "colors.white": {
    "value": "#ffffff",
    "variable": "var(--colors-white)"
  },
  "colors.white.a1": {
    "value": "rgba(255, 255, 255, 0.05)",
    "variable": "var(--colors-white-a1)"
  },
  "colors.white.a2": {
    "value": "rgba(255, 255, 255, 0.1)",
    "variable": "var(--colors-white-a2)"
  },
  "colors.white.a3": {
    "value": "rgba(255, 255, 255, 0.15)",
    "variable": "var(--colors-white-a3)"
  },
  "colors.white.a4": {
    "value": "rgba(255, 255, 255, 0.2)",
    "variable": "var(--colors-white-a4)"
  },
  "colors.white.a5": {
    "value": "rgba(255, 255, 255, 0.3)",
    "variable": "var(--colors-white-a5)"
  },
  "colors.white.a6": {
    "value": "rgba(255, 255, 255, 0.4)",
    "variable": "var(--colors-white-a6)"
  },
  "colors.white.a7": {
    "value": "rgba(255, 255, 255, 0.5)",
    "variable": "var(--colors-white-a7)"
  },
  "colors.white.a8": {
    "value": "rgba(255, 255, 255, 0.6)",
    "variable": "var(--colors-white-a8)"
  },
  "colors.white.a9": {
    "value": "rgba(255, 255, 255, 0.7)",
    "variable": "var(--colors-white-a9)"
  },
  "colors.white.a10": {
    "value": "rgba(255, 255, 255, 0.8)",
    "variable": "var(--colors-white-a10)"
  },
  "colors.white.a11": {
    "value": "rgba(255, 255, 255, 0.9)",
    "variable": "var(--colors-white-a11)"
  },
  "colors.white.a12": {
    "value": "rgba(255, 255, 255, 0.95)",
    "variable": "var(--colors-white-a12)"
  },
  "colors.transparent": {
    "value": "rgb(0 0 0 / 0)",
    "variable": "var(--colors-transparent)"
  },
  "colors.gray.light.1": {
    "value": "#FFFBFF",
    "variable": "var(--colors-gray-light-1)"
  },
  "colors.gray.light.2": {
    "value": "#F3EFF4",
    "variable": "var(--colors-gray-light-2)"
  },
  "colors.gray.light.3": {
    "value": "#E5E1E6",
    "variable": "var(--colors-gray-light-3)"
  },
  "colors.gray.light.4": {
    "value": "#C8C5CA",
    "variable": "var(--colors-gray-light-4)"
  },
  "colors.gray.light.5": {
    "value": "#ADAAAF",
    "variable": "var(--colors-gray-light-5)"
  },
  "colors.gray.light.6": {
    "value": "#929094",
    "variable": "var(--colors-gray-light-6)"
  },
  "colors.gray.light.7": {
    "value": "#78767A",
    "variable": "var(--colors-gray-light-7)"
  },
  "colors.gray.light.8": {
    "value": "#5F5E62",
    "variable": "var(--colors-gray-light-8)"
  },
  "colors.gray.light.9": {
    "value": "#47464A",
    "variable": "var(--colors-gray-light-9)"
  },
  "colors.gray.light.10": {
    "value": "#47464A",
    "variable": "var(--colors-gray-light-10)"
  },
  "colors.gray.light.11": {
    "value": "#343336",
    "variable": "var(--colors-gray-light-11)"
  },
  "colors.gray.light.12": {
    "value": "#1B1B1F",
    "variable": "var(--colors-gray-light-12)"
  },
  "colors.gray.light.a1": {
    "value": "#00000003",
    "variable": "var(--colors-gray-light-a1)"
  },
  "colors.gray.light.a2": {
    "value": "#00000006",
    "variable": "var(--colors-gray-light-a2)"
  },
  "colors.gray.light.a3": {
    "value": "#0000000f",
    "variable": "var(--colors-gray-light-a3)"
  },
  "colors.gray.light.a4": {
    "value": "#00000017",
    "variable": "var(--colors-gray-light-a4)"
  },
  "colors.gray.light.a5": {
    "value": "#0000001f",
    "variable": "var(--colors-gray-light-a5)"
  },
  "colors.gray.light.a6": {
    "value": "#00000026",
    "variable": "var(--colors-gray-light-a6)"
  },
  "colors.gray.light.a7": {
    "value": "#00000031",
    "variable": "var(--colors-gray-light-a7)"
  },
  "colors.gray.light.a8": {
    "value": "#00000044",
    "variable": "var(--colors-gray-light-a8)"
  },
  "colors.gray.light.a9": {
    "value": "#00000072",
    "variable": "var(--colors-gray-light-a9)"
  },
  "colors.gray.light.a10": {
    "value": "#0000007c",
    "variable": "var(--colors-gray-light-a10)"
  },
  "colors.gray.light.a11": {
    "value": "#000000df",
    "variable": "var(--colors-gray-light-a11)"
  },
  "colors.gray.light.a12": {
    "value": "#000000df",
    "variable": "var(--colors-gray-light-a12)"
  },
  "colors.gray.dark.1": {
    "value": "#12131c",
    "variable": "var(--colors-gray-dark-1)"
  },
  "colors.gray.dark.2": {
    "value": "#272831",
    "variable": "var(--colors-gray-dark-2)"
  },
  "colors.gray.dark.3": {
    "value": "#343336",
    "variable": "var(--colors-gray-dark-3)"
  },
  "colors.gray.dark.4": {
    "value": "#787779",
    "variable": "var(--colors-gray-dark-4)"
  },
  "colors.gray.dark.5": {
    "value": "#A5A2A6",
    "variable": "var(--colors-gray-dark-5)"
  },
  "colors.gray.dark.6": {
    "value": "#D2CED2",
    "variable": "var(--colors-gray-dark-6)"
  },
  "colors.gray.dark.7": {
    "value": "#E5DAE8",
    "variable": "var(--colors-gray-dark-7)"
  },
  "colors.gray.dark.8": {
    "value": "#F1E5F3",
    "variable": "var(--colors-gray-dark-8)"
  },
  "colors.gray.dark.9": {
    "value": "#F6E9F8",
    "variable": "var(--colors-gray-dark-9)"
  },
  "colors.gray.dark.10": {
    "value": "#F6E9F8",
    "variable": "var(--colors-gray-dark-10)"
  },
  "colors.gray.dark.11": {
    "value": "#F9ECFA",
    "variable": "var(--colors-gray-dark-11)"
  },
  "colors.gray.dark.12": {
    "value": "#F9ECFA",
    "variable": "var(--colors-gray-dark-12)"
  },
  "colors.gray.dark.a1": {
    "value": "#00000000",
    "variable": "var(--colors-gray-dark-a1)"
  },
  "colors.gray.dark.a2": {
    "value": "#ffffff09",
    "variable": "var(--colors-gray-dark-a2)"
  },
  "colors.gray.dark.a3": {
    "value": "#ffffff12",
    "variable": "var(--colors-gray-dark-a3)"
  },
  "colors.gray.dark.a4": {
    "value": "#ffffff1b",
    "variable": "var(--colors-gray-dark-a4)"
  },
  "colors.gray.dark.a5": {
    "value": "#ffffff22",
    "variable": "var(--colors-gray-dark-a5)"
  },
  "colors.gray.dark.a6": {
    "value": "#ffffff2c",
    "variable": "var(--colors-gray-dark-a6)"
  },
  "colors.gray.dark.a7": {
    "value": "#ffffff3b",
    "variable": "var(--colors-gray-dark-a7)"
  },
  "colors.gray.dark.a8": {
    "value": "#ffffff55",
    "variable": "var(--colors-gray-dark-a8)"
  },
  "colors.gray.dark.a9": {
    "value": "#ffffff64",
    "variable": "var(--colors-gray-dark-a9)"
  },
  "colors.gray.dark.a10": {
    "value": "#ffffff72",
    "variable": "var(--colors-gray-dark-a10)"
  },
  "colors.gray.dark.a11": {
    "value": "#ffffffaf",
    "variable": "var(--colors-gray-dark-a11)"
  },
  "colors.gray.dark.a12": {
    "value": "#ffffffed",
    "variable": "var(--colors-gray-dark-a12)"
  },
  "colors.primary.light.1": {
    "value": "#F2F5FF",
    "variable": "var(--colors-primary-light-1)"
  },
  "colors.primary.light.2": {
    "value": "#E7EBFF",
    "variable": "var(--colors-primary-light-2)"
  },
  "colors.primary.light.3": {
    "value": "#D2DBFF",
    "variable": "var(--colors-primary-light-3)"
  },
  "colors.primary.light.4": {
    "value": "#AEBAFF",
    "variable": "var(--colors-primary-light-4)"
  },
  "colors.primary.light.5": {
    "value": "#808EFF",
    "variable": "var(--colors-primary-light-5)"
  },
  "colors.primary.light.6": {
    "value": "#4D57FF",
    "variable": "var(--colors-primary-light-6)"
  },
  "colors.primary.light.7": {
    "value": "#2424FF",
    "variable": "var(--colors-primary-light-7)"
  },
  "colors.primary.light.8": {
    "value": "#1A16EB",
    "variable": "var(--colors-primary-light-8)"
  },
  "colors.primary.light.9": {
    "value": "#1612C5",
    "variable": "var(--colors-primary-light-9)"
  },
  "colors.primary.light.10": {
    "value": "#1411A1",
    "variable": "var(--colors-primary-light-10)"
  },
  "colors.primary.light.11": {
    "value": "#131353",
    "variable": "var(--colors-primary-light-11)"
  },
  "colors.primary.light.12": {
    "value": "#131353",
    "variable": "var(--colors-primary-light-12)"
  },
  "colors.primary.light.a1": {
    "value": "#F2F5FF04",
    "variable": "var(--colors-primary-light-a1)"
  },
  "colors.primary.light.a2": {
    "value": "#E7EBFF16",
    "variable": "var(--colors-primary-light-a2)"
  },
  "colors.primary.light.a3": {
    "value": "#D2DBFF3d",
    "variable": "var(--colors-primary-light-a3)"
  },
  "colors.primary.light.a4": {
    "value": "#AEBAFF63",
    "variable": "var(--colors-primary-light-a4)"
  },
  "colors.primary.light.a5": {
    "value": "#808EFF88",
    "variable": "var(--colors-primary-light-a5)"
  },
  "colors.primary.light.a6": {
    "value": "#4D57FF8c",
    "variable": "var(--colors-primary-light-a6)"
  },
  "colors.primary.light.a7": {
    "value": "#2424FF9d",
    "variable": "var(--colors-primary-light-a7)"
  },
  "colors.primary.light.a8": {
    "value": "#1A16EBc9",
    "variable": "var(--colors-primary-light-a8)"
  },
  "colors.primary.light.a9": {
    "value": "#1612C5c2",
    "variable": "var(--colors-primary-light-a9)"
  },
  "colors.primary.light.a10": {
    "value": "#1411A1e7",
    "variable": "var(--colors-primary-light-a10)"
  },
  "colors.primary.light.a11": {
    "value": "#131353",
    "variable": "var(--colors-primary-light-a11)"
  },
  "colors.primary.light.a12": {
    "value": "#131353dd",
    "variable": "var(--colors-primary-light-a12)"
  },
  "colors.primary.dark.1": {
    "value": "#222245",
    "variable": "var(--colors-primary-dark-1)"
  },
  "colors.primary.dark.2": {
    "value": "#2D2E5B",
    "variable": "var(--colors-primary-dark-2)"
  },
  "colors.primary.dark.3": {
    "value": "#393B7E",
    "variable": "var(--colors-primary-dark-3)"
  },
  "colors.primary.dark.4": {
    "value": "#3A36B3",
    "variable": "var(--colors-primary-dark-4)"
  },
  "colors.primary.dark.5": {
    "value": "#4C4CD9",
    "variable": "var(--colors-primary-dark-5)"
  },
  "colors.primary.dark.6": {
    "value": "#666BFF",
    "variable": "var(--colors-primary-dark-6)"
  },
  "colors.primary.dark.7": {
    "value": "#8F96FF",
    "variable": "var(--colors-primary-dark-7)"
  },
  "colors.primary.dark.8": {
    "value": "#B8BFFF",
    "variable": "var(--colors-primary-dark-8)"
  },
  "colors.primary.dark.9": {
    "value": "#F0F2FF",
    "variable": "var(--colors-primary-dark-9)"
  },
  "colors.primary.dark.10": {
    "value": "#F0F3FF",
    "variable": "var(--colors-primary-dark-10)"
  },
  "colors.primary.dark.11": {
    "value": "#F0F3FF",
    "variable": "var(--colors-primary-dark-11)"
  },
  "colors.primary.dark.12": {
    "value": "#F0F3FF",
    "variable": "var(--colors-primary-dark-12)"
  },
  "colors.primary.dark.a1": {
    "value": "#22224506",
    "variable": "var(--colors-primary-dark-a1)"
  },
  "colors.primary.dark.a2": {
    "value": "#2D2E5B0d",
    "variable": "var(--colors-primary-dark-a2)"
  },
  "colors.primary.dark.a3": {
    "value": "#2D2E5B22",
    "variable": "var(--colors-primary-dark-a3)"
  },
  "colors.primary.dark.a4": {
    "value": "#393B7E32",
    "variable": "var(--colors-primary-dark-a4)"
  },
  "colors.primary.dark.a5": {
    "value": "#3A36B341",
    "variable": "var(--colors-primary-dark-a5)"
  },
  "colors.primary.dark.a6": {
    "value": "#4C4CD951",
    "variable": "var(--colors-primary-dark-a6)"
  },
  "colors.primary.dark.a7": {
    "value": "#666BFF67",
    "variable": "var(--colors-primary-dark-a7)"
  },
  "colors.primary.dark.a8": {
    "value": "#666BFF87",
    "variable": "var(--colors-primary-dark-a8)"
  },
  "colors.primary.dark.a9": {
    "value": "#666BFF",
    "variable": "var(--colors-primary-dark-a9)"
  },
  "colors.primary.dark.a10": {
    "value": "#B8BFFF",
    "variable": "var(--colors-primary-dark-a10)"
  },
  "colors.primary.dark.a11": {
    "value": "#8F96FF",
    "variable": "var(--colors-primary-dark-a11)"
  },
  "colors.primary.dark.a12": {
    "value": "#F0F2FF",
    "variable": "var(--colors-primary-dark-a12)"
  },
  "colors.blue.50": {
    "value": "var(--colors-blue-50)",
    "variable": "var(--colors-blue-50)"
  },
  "colors.blue.100": {
    "value": "var(--colors-blue-100)",
    "variable": "var(--colors-blue-100)"
  },
  "colors.blue.200": {
    "value": "var(--colors-blue-200)",
    "variable": "var(--colors-blue-200)"
  },
  "colors.blue.300": {
    "value": "var(--colors-blue-300)",
    "variable": "var(--colors-blue-300)"
  },
  "colors.blue.400": {
    "value": "var(--colors-blue-400)",
    "variable": "var(--colors-blue-400)"
  },
  "colors.blue.500": {
    "value": "var(--colors-blue-500)",
    "variable": "var(--colors-blue-500)"
  },
  "colors.blue.600": {
    "value": "var(--colors-blue-600)",
    "variable": "var(--colors-blue-600)"
  },
  "colors.blue.700": {
    "value": "var(--colors-blue-700)",
    "variable": "var(--colors-blue-700)"
  },
  "colors.blue.800": {
    "value": "var(--colors-blue-800)",
    "variable": "var(--colors-blue-800)"
  },
  "colors.blue.900": {
    "value": "var(--colors-blue-900)",
    "variable": "var(--colors-blue-900)"
  },
  "colors.blue.950": {
    "value": "var(--colors-blue-950)",
    "variable": "var(--colors-blue-950)"
  },
  "colors.green.50": {
    "value": "var(--colors-green-50)",
    "variable": "var(--colors-green-50)"
  },
  "colors.green.100": {
    "value": "var(--colors-green-100)",
    "variable": "var(--colors-green-100)"
  },
  "colors.green.200": {
    "value": "var(--colors-green-200)",
    "variable": "var(--colors-green-200)"
  },
  "colors.green.300": {
    "value": "var(--colors-green-300)",
    "variable": "var(--colors-green-300)"
  },
  "colors.green.400": {
    "value": "var(--colors-green-400)",
    "variable": "var(--colors-green-400)"
  },
  "colors.green.500": {
    "value": "var(--colors-green-500)",
    "variable": "var(--colors-green-500)"
  },
  "colors.green.600": {
    "value": "var(--colors-green-600)",
    "variable": "var(--colors-green-600)"
  },
  "colors.green.700": {
    "value": "var(--colors-green-700)",
    "variable": "var(--colors-green-700)"
  },
  "colors.green.800": {
    "value": "var(--colors-green-800)",
    "variable": "var(--colors-green-800)"
  },
  "colors.green.900": {
    "value": "var(--colors-green-900)",
    "variable": "var(--colors-green-900)"
  },
  "colors.green.950": {
    "value": "var(--colors-green-950)",
    "variable": "var(--colors-green-950)"
  },
  "colors.neutral.50": {
    "value": "var(--colors-neutral-50)",
    "variable": "var(--colors-neutral-50)"
  },
  "colors.neutral.100": {
    "value": "var(--colors-neutral-100)",
    "variable": "var(--colors-neutral-100)"
  },
  "colors.neutral.200": {
    "value": "var(--colors-neutral-200)",
    "variable": "var(--colors-neutral-200)"
  },
  "colors.neutral.300": {
    "value": "var(--colors-neutral-300)",
    "variable": "var(--colors-neutral-300)"
  },
  "colors.neutral.400": {
    "value": "var(--colors-neutral-400)",
    "variable": "var(--colors-neutral-400)"
  },
  "colors.neutral.500": {
    "value": "var(--colors-neutral-500)",
    "variable": "var(--colors-neutral-500)"
  },
  "colors.neutral.600": {
    "value": "var(--colors-neutral-600)",
    "variable": "var(--colors-neutral-600)"
  },
  "colors.neutral.700": {
    "value": "var(--colors-neutral-700)",
    "variable": "var(--colors-neutral-700)"
  },
  "colors.neutral.800": {
    "value": "var(--colors-neutral-800)",
    "variable": "var(--colors-neutral-800)"
  },
  "colors.neutral.900": {
    "value": "var(--colors-neutral-900)",
    "variable": "var(--colors-neutral-900)"
  },
  "colors.neutral.950": {
    "value": "var(--colors-neutral-950)",
    "variable": "var(--colors-neutral-950)"
  },
  "colors.neutralVariant.50": {
    "value": "var(--colors-neutral-variant-50)",
    "variable": "var(--colors-neutral-variant-50)"
  },
  "colors.neutralVariant.100": {
    "value": "var(--colors-neutral-variant-100)",
    "variable": "var(--colors-neutral-variant-100)"
  },
  "colors.neutralVariant.200": {
    "value": "var(--colors-neutral-variant-200)",
    "variable": "var(--colors-neutral-variant-200)"
  },
  "colors.neutralVariant.300": {
    "value": "var(--colors-neutral-variant-300)",
    "variable": "var(--colors-neutral-variant-300)"
  },
  "colors.neutralVariant.400": {
    "value": "var(--colors-neutral-variant-400)",
    "variable": "var(--colors-neutral-variant-400)"
  },
  "colors.neutralVariant.500": {
    "value": "var(--colors-neutral-variant-500)",
    "variable": "var(--colors-neutral-variant-500)"
  },
  "colors.neutralVariant.600": {
    "value": "var(--colors-neutral-variant-600)",
    "variable": "var(--colors-neutral-variant-600)"
  },
  "colors.neutralVariant.700": {
    "value": "var(--colors-neutral-variant-700)",
    "variable": "var(--colors-neutral-variant-700)"
  },
  "colors.neutralVariant.800": {
    "value": "var(--colors-neutral-variant-800)",
    "variable": "var(--colors-neutral-variant-800)"
  },
  "colors.neutralVariant.900": {
    "value": "var(--colors-neutral-variant-900)",
    "variable": "var(--colors-neutral-variant-900)"
  },
  "colors.neutralVariant.950": {
    "value": "var(--colors-neutral-variant-950)",
    "variable": "var(--colors-neutral-variant-950)"
  },
  "colors.orange.50": {
    "value": "var(--colors-orange-50)",
    "variable": "var(--colors-orange-50)"
  },
  "colors.orange.100": {
    "value": "var(--colors-orange-100)",
    "variable": "var(--colors-orange-100)"
  },
  "colors.orange.200": {
    "value": "var(--colors-orange-200)",
    "variable": "var(--colors-orange-200)"
  },
  "colors.orange.300": {
    "value": "var(--colors-orange-300)",
    "variable": "var(--colors-orange-300)"
  },
  "colors.orange.400": {
    "value": "var(--colors-orange-400)",
    "variable": "var(--colors-orange-400)"
  },
  "colors.orange.500": {
    "value": "var(--colors-orange-500)",
    "variable": "var(--colors-orange-500)"
  },
  "colors.orange.600": {
    "value": "var(--colors-orange-600)",
    "variable": "var(--colors-orange-600)"
  },
  "colors.orange.700": {
    "value": "var(--colors-orange-700)",
    "variable": "var(--colors-orange-700)"
  },
  "colors.orange.800": {
    "value": "var(--colors-orange-800)",
    "variable": "var(--colors-orange-800)"
  },
  "colors.orange.900": {
    "value": "var(--colors-orange-900)",
    "variable": "var(--colors-orange-900)"
  },
  "colors.orange.950": {
    "value": "var(--colors-orange-950)",
    "variable": "var(--colors-orange-950)"
  },
  "colors.red.50": {
    "value": "var(--colors-red-50)",
    "variable": "var(--colors-red-50)"
  },
  "colors.red.100": {
    "value": "var(--colors-red-100)",
    "variable": "var(--colors-red-100)"
  },
  "colors.red.200": {
    "value": "var(--colors-red-200)",
    "variable": "var(--colors-red-200)"
  },
  "colors.red.300": {
    "value": "var(--colors-red-300)",
    "variable": "var(--colors-red-300)"
  },
  "colors.red.400": {
    "value": "var(--colors-red-400)",
    "variable": "var(--colors-red-400)"
  },
  "colors.red.500": {
    "value": "var(--colors-red-500)",
    "variable": "var(--colors-red-500)"
  },
  "colors.red.600": {
    "value": "var(--colors-red-600)",
    "variable": "var(--colors-red-600)"
  },
  "colors.red.700": {
    "value": "var(--colors-red-700)",
    "variable": "var(--colors-red-700)"
  },
  "colors.red.800": {
    "value": "var(--colors-red-800)",
    "variable": "var(--colors-red-800)"
  },
  "colors.red.900": {
    "value": "var(--colors-red-900)",
    "variable": "var(--colors-red-900)"
  },
  "colors.red.950": {
    "value": "var(--colors-red-950)",
    "variable": "var(--colors-red-950)"
  },
  "colors.red.light.1": {
    "value": "#fffcfc",
    "variable": "var(--colors-red-light-1)"
  },
  "colors.red.light.2": {
    "value": "#fff7f7",
    "variable": "var(--colors-red-light-2)"
  },
  "colors.red.light.3": {
    "value": "#feebec",
    "variable": "var(--colors-red-light-3)"
  },
  "colors.red.light.4": {
    "value": "#ffdbdc",
    "variable": "var(--colors-red-light-4)"
  },
  "colors.red.light.5": {
    "value": "#ffcdce",
    "variable": "var(--colors-red-light-5)"
  },
  "colors.red.light.6": {
    "value": "#fdbdbe",
    "variable": "var(--colors-red-light-6)"
  },
  "colors.red.light.7": {
    "value": "#f4a9aa",
    "variable": "var(--colors-red-light-7)"
  },
  "colors.red.light.8": {
    "value": "#eb8e90",
    "variable": "var(--colors-red-light-8)"
  },
  "colors.red.light.9": {
    "value": "#e5484d",
    "variable": "var(--colors-red-light-9)"
  },
  "colors.red.light.10": {
    "value": "#dc3e42",
    "variable": "var(--colors-red-light-10)"
  },
  "colors.red.light.11": {
    "value": "#ce2c31",
    "variable": "var(--colors-red-light-11)"
  },
  "colors.red.light.12": {
    "value": "#641723",
    "variable": "var(--colors-red-light-12)"
  },
  "colors.red.light.a1": {
    "value": "#ff000003",
    "variable": "var(--colors-red-light-a1)"
  },
  "colors.red.light.a2": {
    "value": "#ff000008",
    "variable": "var(--colors-red-light-a2)"
  },
  "colors.red.light.a3": {
    "value": "#f3000d14",
    "variable": "var(--colors-red-light-a3)"
  },
  "colors.red.light.a4": {
    "value": "#ff000824",
    "variable": "var(--colors-red-light-a4)"
  },
  "colors.red.light.a5": {
    "value": "#ff000632",
    "variable": "var(--colors-red-light-a5)"
  },
  "colors.red.light.a6": {
    "value": "#f8000442",
    "variable": "var(--colors-red-light-a6)"
  },
  "colors.red.light.a7": {
    "value": "#df000356",
    "variable": "var(--colors-red-light-a7)"
  },
  "colors.red.light.a8": {
    "value": "#d2000571",
    "variable": "var(--colors-red-light-a8)"
  },
  "colors.red.light.a9": {
    "value": "#db0007b7",
    "variable": "var(--colors-red-light-a9)"
  },
  "colors.red.light.a10": {
    "value": "#d10005c1",
    "variable": "var(--colors-red-light-a10)"
  },
  "colors.red.light.a11": {
    "value": "#c40006d3",
    "variable": "var(--colors-red-light-a11)"
  },
  "colors.red.light.a12": {
    "value": "#55000de8",
    "variable": "var(--colors-red-light-a12)"
  },
  "colors.red.dark.1": {
    "value": "#191111",
    "variable": "var(--colors-red-dark-1)"
  },
  "colors.red.dark.2": {
    "value": "#201314",
    "variable": "var(--colors-red-dark-2)"
  },
  "colors.red.dark.3": {
    "value": "#3b1219",
    "variable": "var(--colors-red-dark-3)"
  },
  "colors.red.dark.4": {
    "value": "#500f1c",
    "variable": "var(--colors-red-dark-4)"
  },
  "colors.red.dark.5": {
    "value": "#611623",
    "variable": "var(--colors-red-dark-5)"
  },
  "colors.red.dark.6": {
    "value": "#72232d",
    "variable": "var(--colors-red-dark-6)"
  },
  "colors.red.dark.7": {
    "value": "#8c333a",
    "variable": "var(--colors-red-dark-7)"
  },
  "colors.red.dark.8": {
    "value": "#b54548",
    "variable": "var(--colors-red-dark-8)"
  },
  "colors.red.dark.9": {
    "value": "#e5484d",
    "variable": "var(--colors-red-dark-9)"
  },
  "colors.red.dark.10": {
    "value": "#ec5d5e",
    "variable": "var(--colors-red-dark-10)"
  },
  "colors.red.dark.11": {
    "value": "#ff9592",
    "variable": "var(--colors-red-dark-11)"
  },
  "colors.red.dark.12": {
    "value": "#ffd1d9",
    "variable": "var(--colors-red-dark-12)"
  },
  "colors.red.dark.a1": {
    "value": "#f4121209",
    "variable": "var(--colors-red-dark-a1)"
  },
  "colors.red.dark.a2": {
    "value": "#f22f3e11",
    "variable": "var(--colors-red-dark-a2)"
  },
  "colors.red.dark.a3": {
    "value": "#ff173f2d",
    "variable": "var(--colors-red-dark-a3)"
  },
  "colors.red.dark.a4": {
    "value": "#fe0a3b44",
    "variable": "var(--colors-red-dark-a4)"
  },
  "colors.red.dark.a5": {
    "value": "#ff204756",
    "variable": "var(--colors-red-dark-a5)"
  },
  "colors.red.dark.a6": {
    "value": "#ff3e5668",
    "variable": "var(--colors-red-dark-a6)"
  },
  "colors.red.dark.a7": {
    "value": "#ff536184",
    "variable": "var(--colors-red-dark-a7)"
  },
  "colors.red.dark.a8": {
    "value": "#ff5d61b0",
    "variable": "var(--colors-red-dark-a8)"
  },
  "colors.red.dark.a9": {
    "value": "#fe4e54e4",
    "variable": "var(--colors-red-dark-a9)"
  },
  "colors.red.dark.a10": {
    "value": "#ff6465eb",
    "variable": "var(--colors-red-dark-a10)"
  },
  "colors.red.dark.a11": {
    "value": "#ff9592",
    "variable": "var(--colors-red-dark-a11)"
  },
  "colors.red.dark.a12": {
    "value": "#ffd1d9",
    "variable": "var(--colors-red-dark-a12)"
  },
  "colors.yellow.50": {
    "value": "var(--colors-yellow-50)",
    "variable": "var(--colors-yellow-50)"
  },
  "colors.yellow.100": {
    "value": "var(--colors-yellow-100)",
    "variable": "var(--colors-yellow-100)"
  },
  "colors.yellow.200": {
    "value": "var(--colors-yellow-200)",
    "variable": "var(--colors-yellow-200)"
  },
  "colors.yellow.300": {
    "value": "var(--colors-yellow-300)",
    "variable": "var(--colors-yellow-300)"
  },
  "colors.yellow.400": {
    "value": "var(--colors-yellow-400)",
    "variable": "var(--colors-yellow-400)"
  },
  "colors.yellow.500": {
    "value": "var(--colors-yellow-500)",
    "variable": "var(--colors-yellow-500)"
  },
  "colors.yellow.600": {
    "value": "var(--colors-yellow-600)",
    "variable": "var(--colors-yellow-600)"
  },
  "colors.yellow.700": {
    "value": "var(--colors-yellow-700)",
    "variable": "var(--colors-yellow-700)"
  },
  "colors.yellow.800": {
    "value": "var(--colors-yellow-800)",
    "variable": "var(--colors-yellow-800)"
  },
  "colors.yellow.900": {
    "value": "var(--colors-yellow-900)",
    "variable": "var(--colors-yellow-900)"
  },
  "colors.yellow.950": {
    "value": "var(--colors-yellow-950)",
    "variable": "var(--colors-yellow-950)"
  },
  "sizes.0": {
    "value": "0rem",
    "variable": "var(--sizes-0)"
  },
  "sizes.1": {
    "value": "0.25rem",
    "variable": "var(--sizes-1)"
  },
  "sizes.2": {
    "value": "0.5rem",
    "variable": "var(--sizes-2)"
  },
  "sizes.3": {
    "value": "0.75rem",
    "variable": "var(--sizes-3)"
  },
  "sizes.4": {
    "value": "1rem",
    "variable": "var(--sizes-4)"
  },
  "sizes.5": {
    "value": "1.25rem",
    "variable": "var(--sizes-5)"
  },
  "sizes.6": {
    "value": "1.5rem",
    "variable": "var(--sizes-6)"
  },
  "sizes.7": {
    "value": "1.75rem",
    "variable": "var(--sizes-7)"
  },
  "sizes.8": {
    "value": "2rem",
    "variable": "var(--sizes-8)"
  },
  "sizes.9": {
    "value": "2.25rem",
    "variable": "var(--sizes-9)"
  },
  "sizes.10": {
    "value": "2.5rem",
    "variable": "var(--sizes-10)"
  },
  "sizes.11": {
    "value": "2.75rem",
    "variable": "var(--sizes-11)"
  },
  "sizes.12": {
    "value": "3rem",
    "variable": "var(--sizes-12)"
  },
  "sizes.14": {
    "value": "3.5rem",
    "variable": "var(--sizes-14)"
  },
  "sizes.16": {
    "value": "4rem",
    "variable": "var(--sizes-16)"
  },
  "sizes.20": {
    "value": "5rem",
    "variable": "var(--sizes-20)"
  },
  "sizes.24": {
    "value": "6rem",
    "variable": "var(--sizes-24)"
  },
  "sizes.28": {
    "value": "7rem",
    "variable": "var(--sizes-28)"
  },
  "sizes.32": {
    "value": "8rem",
    "variable": "var(--sizes-32)"
  },
  "sizes.36": {
    "value": "9rem",
    "variable": "var(--sizes-36)"
  },
  "sizes.40": {
    "value": "10rem",
    "variable": "var(--sizes-40)"
  },
  "sizes.44": {
    "value": "11rem",
    "variable": "var(--sizes-44)"
  },
  "sizes.48": {
    "value": "12rem",
    "variable": "var(--sizes-48)"
  },
  "sizes.52": {
    "value": "13rem",
    "variable": "var(--sizes-52)"
  },
  "sizes.56": {
    "value": "14rem",
    "variable": "var(--sizes-56)"
  },
  "sizes.60": {
    "value": "15rem",
    "variable": "var(--sizes-60)"
  },
  "sizes.64": {
    "value": "16rem",
    "variable": "var(--sizes-64)"
  },
  "sizes.72": {
    "value": "18rem",
    "variable": "var(--sizes-72)"
  },
  "sizes.80": {
    "value": "20rem",
    "variable": "var(--sizes-80)"
  },
  "sizes.96": {
    "value": "24rem",
    "variable": "var(--sizes-96)"
  },
  "sizes.0.5": {
    "value": "0.125rem",
    "variable": "var(--sizes-0\\.5)"
  },
  "sizes.1.5": {
    "value": "0.375rem",
    "variable": "var(--sizes-1\\.5)"
  },
  "sizes.2.5": {
    "value": "0.625rem",
    "variable": "var(--sizes-2\\.5)"
  },
  "sizes.3.5": {
    "value": "0.875rem",
    "variable": "var(--sizes-3\\.5)"
  },
  "sizes.4.5": {
    "value": "1.125rem",
    "variable": "var(--sizes-4\\.5)"
  },
  "sizes.2xs": {
    "value": "16rem",
    "variable": "var(--sizes-2xs)"
  },
  "sizes.xs": {
    "value": "20rem",
    "variable": "var(--sizes-xs)"
  },
  "sizes.sm": {
    "value": "24rem",
    "variable": "var(--sizes-sm)"
  },
  "sizes.md": {
    "value": "28rem",
    "variable": "var(--sizes-md)"
  },
  "sizes.lg": {
    "value": "32rem",
    "variable": "var(--sizes-lg)"
  },
  "sizes.xl": {
    "value": "36rem",
    "variable": "var(--sizes-xl)"
  },
  "sizes.2xl": {
    "value": "42rem",
    "variable": "var(--sizes-2xl)"
  },
  "sizes.3xl": {
    "value": "48rem",
    "variable": "var(--sizes-3xl)"
  },
  "sizes.4xl": {
    "value": "56rem",
    "variable": "var(--sizes-4xl)"
  },
  "sizes.5xl": {
    "value": "64rem",
    "variable": "var(--sizes-5xl)"
  },
  "sizes.6xl": {
    "value": "72rem",
    "variable": "var(--sizes-6xl)"
  },
  "sizes.7xl": {
    "value": "80rem",
    "variable": "var(--sizes-7xl)"
  },
  "sizes.8xl": {
    "value": "90rem",
    "variable": "var(--sizes-8xl)"
  },
  "sizes.full": {
    "value": "100%",
    "variable": "var(--sizes-full)"
  },
  "sizes.min": {
    "value": "min-content",
    "variable": "var(--sizes-min)"
  },
  "sizes.max": {
    "value": "max-content",
    "variable": "var(--sizes-max)"
  },
  "sizes.fit": {
    "value": "fit-content",
    "variable": "var(--sizes-fit)"
  },
  "sizes.fullVW": {
    "value": "var(--sizes-full-v-w)",
    "variable": "var(--sizes-full-v-w)"
  },
  "sizes.fullVH": {
    "value": "var(--sizes-full-v-h)",
    "variable": "var(--sizes-full-v-h)"
  },
  "sizes.navbarExpandedWidth": {
    "value": "var(--sizes-navbar-expanded-width)",
    "variable": "var(--sizes-navbar-expanded-width)"
  },
  "sizes.navbarCollapsedWidth": {
    "value": "var(--sizes-navbar-collapsed-width)",
    "variable": "var(--sizes-navbar-collapsed-width)"
  },
  "sizes.breakpoint-sm": {
    "value": "640px",
    "variable": "var(--sizes-breakpoint-sm)"
  },
  "sizes.breakpoint-md": {
    "value": "768px",
    "variable": "var(--sizes-breakpoint-md)"
  },
  "sizes.breakpoint-lg": {
    "value": "1024px",
    "variable": "var(--sizes-breakpoint-lg)"
  },
  "sizes.breakpoint-xl": {
    "value": "1280px",
    "variable": "var(--sizes-breakpoint-xl)"
  },
  "sizes.breakpoint-2xl": {
    "value": "1536px",
    "variable": "var(--sizes-breakpoint-2xl)"
  },
  "breakpoints.sm": {
    "value": "640px",
    "variable": "var(--breakpoints-sm)"
  },
  "breakpoints.md": {
    "value": "768px",
    "variable": "var(--breakpoints-md)"
  },
  "breakpoints.lg": {
    "value": "1024px",
    "variable": "var(--breakpoints-lg)"
  },
  "breakpoints.xl": {
    "value": "1280px",
    "variable": "var(--breakpoints-xl)"
  },
  "breakpoints.2xl": {
    "value": "1536px",
    "variable": "var(--breakpoints-2xl)"
  },
  "radii.l1": {
    "value": "var(--radii-xs)",
    "variable": "var(--radii-l1)"
  },
  "radii.l2": {
    "value": "var(--radii-sm)",
    "variable": "var(--radii-l2)"
  },
  "radii.l3": {
    "value": "var(--radii-md)",
    "variable": "var(--radii-l3)"
  },
  "colors.success.50": {
    "value": "var(--colors-success-50)",
    "variable": "var(--colors-success-50)"
  },
  "colors.success.100": {
    "value": "var(--colors-success-100)",
    "variable": "var(--colors-success-100)"
  },
  "colors.success.200": {
    "value": "var(--colors-success-200)",
    "variable": "var(--colors-success-200)"
  },
  "colors.success.300": {
    "value": "var(--colors-success-300)",
    "variable": "var(--colors-success-300)"
  },
  "colors.success.400": {
    "value": "var(--colors-success-400)",
    "variable": "var(--colors-success-400)"
  },
  "colors.success.500": {
    "value": "var(--colors-success-500)",
    "variable": "var(--colors-success-500)"
  },
  "colors.success.600": {
    "value": "var(--colors-success-600)",
    "variable": "var(--colors-success-600)"
  },
  "colors.success.700": {
    "value": "var(--colors-success-700)",
    "variable": "var(--colors-success-700)"
  },
  "colors.success.800": {
    "value": "var(--colors-success-800)",
    "variable": "var(--colors-success-800)"
  },
  "colors.success.900": {
    "value": "var(--colors-success-900)",
    "variable": "var(--colors-success-900)"
  },
  "colors.success.950": {
    "value": "var(--colors-success-950)",
    "variable": "var(--colors-success-950)"
  },
  "colors.success": {
    "value": "var(--colors-success)",
    "variable": "var(--colors-success)"
  },
  "colors.error.50": {
    "value": "var(--colors-error-50)",
    "variable": "var(--colors-error-50)"
  },
  "colors.error.100": {
    "value": "var(--colors-error-100)",
    "variable": "var(--colors-error-100)"
  },
  "colors.error.200": {
    "value": "var(--colors-error-200)",
    "variable": "var(--colors-error-200)"
  },
  "colors.error.300": {
    "value": "var(--colors-error-300)",
    "variable": "var(--colors-error-300)"
  },
  "colors.error.400": {
    "value": "var(--colors-error-400)",
    "variable": "var(--colors-error-400)"
  },
  "colors.error.500": {
    "value": "var(--colors-error-500)",
    "variable": "var(--colors-error-500)"
  },
  "colors.error.600": {
    "value": "var(--colors-error-600)",
    "variable": "var(--colors-error-600)"
  },
  "colors.error.700": {
    "value": "var(--colors-error-700)",
    "variable": "var(--colors-error-700)"
  },
  "colors.error.800": {
    "value": "var(--colors-error-800)",
    "variable": "var(--colors-error-800)"
  },
  "colors.error.900": {
    "value": "var(--colors-error-900)",
    "variable": "var(--colors-error-900)"
  },
  "colors.error.950": {
    "value": "var(--colors-error-950)",
    "variable": "var(--colors-error-950)"
  },
  "colors.error": {
    "value": "var(--colors-error)",
    "variable": "var(--colors-error)"
  },
  "colors.primary.50": {
    "value": "var(--colors-primary-50)",
    "variable": "var(--colors-primary-50)"
  },
  "colors.primary.100": {
    "value": "var(--colors-primary-100)",
    "variable": "var(--colors-primary-100)"
  },
  "colors.primary.200": {
    "value": "var(--colors-primary-200)",
    "variable": "var(--colors-primary-200)"
  },
  "colors.primary.300": {
    "value": "var(--colors-primary-300)",
    "variable": "var(--colors-primary-300)"
  },
  "colors.primary.400": {
    "value": "var(--colors-primary-400)",
    "variable": "var(--colors-primary-400)"
  },
  "colors.primary.500": {
    "value": "var(--colors-primary-500)",
    "variable": "var(--colors-primary-500)"
  },
  "colors.primary.600": {
    "value": "var(--colors-primary-600)",
    "variable": "var(--colors-primary-600)"
  },
  "colors.primary.700": {
    "value": "var(--colors-primary-700)",
    "variable": "var(--colors-primary-700)"
  },
  "colors.primary.800": {
    "value": "var(--colors-primary-800)",
    "variable": "var(--colors-primary-800)"
  },
  "colors.primary.900": {
    "value": "var(--colors-primary-900)",
    "variable": "var(--colors-primary-900)"
  },
  "colors.primary.950": {
    "value": "var(--colors-primary-950)",
    "variable": "var(--colors-primary-950)"
  },
  "colors.primary": {
    "value": "var(--colors-primary)",
    "variable": "var(--colors-primary)"
  },
  "colors.secondary.50": {
    "value": "var(--colors-secondary-50)",
    "variable": "var(--colors-secondary-50)"
  },
  "colors.secondary.100": {
    "value": "var(--colors-secondary-100)",
    "variable": "var(--colors-secondary-100)"
  },
  "colors.secondary.200": {
    "value": "var(--colors-secondary-200)",
    "variable": "var(--colors-secondary-200)"
  },
  "colors.secondary.300": {
    "value": "var(--colors-secondary-300)",
    "variable": "var(--colors-secondary-300)"
  },
  "colors.secondary.400": {
    "value": "var(--colors-secondary-400)",
    "variable": "var(--colors-secondary-400)"
  },
  "colors.secondary.500": {
    "value": "var(--colors-secondary-500)",
    "variable": "var(--colors-secondary-500)"
  },
  "colors.secondary.600": {
    "value": "var(--colors-secondary-600)",
    "variable": "var(--colors-secondary-600)"
  },
  "colors.secondary.700": {
    "value": "var(--colors-secondary-700)",
    "variable": "var(--colors-secondary-700)"
  },
  "colors.secondary.800": {
    "value": "var(--colors-secondary-800)",
    "variable": "var(--colors-secondary-800)"
  },
  "colors.secondary.900": {
    "value": "var(--colors-secondary-900)",
    "variable": "var(--colors-secondary-900)"
  },
  "colors.secondary.950": {
    "value": "var(--colors-secondary-950)",
    "variable": "var(--colors-secondary-950)"
  },
  "colors.secondary": {
    "value": "var(--colors-secondary)",
    "variable": "var(--colors-secondary)"
  },
  "colors.tertiary.50": {
    "value": "var(--colors-tertiary-50)",
    "variable": "var(--colors-tertiary-50)"
  },
  "colors.tertiary.100": {
    "value": "var(--colors-tertiary-100)",
    "variable": "var(--colors-tertiary-100)"
  },
  "colors.tertiary.200": {
    "value": "var(--colors-tertiary-200)",
    "variable": "var(--colors-tertiary-200)"
  },
  "colors.tertiary.300": {
    "value": "var(--colors-tertiary-300)",
    "variable": "var(--colors-tertiary-300)"
  },
  "colors.tertiary.400": {
    "value": "var(--colors-tertiary-400)",
    "variable": "var(--colors-tertiary-400)"
  },
  "colors.tertiary.500": {
    "value": "var(--colors-tertiary-500)",
    "variable": "var(--colors-tertiary-500)"
  },
  "colors.tertiary.600": {
    "value": "var(--colors-tertiary-600)",
    "variable": "var(--colors-tertiary-600)"
  },
  "colors.tertiary.700": {
    "value": "var(--colors-tertiary-700)",
    "variable": "var(--colors-tertiary-700)"
  },
  "colors.tertiary.800": {
    "value": "var(--colors-tertiary-800)",
    "variable": "var(--colors-tertiary-800)"
  },
  "colors.tertiary.900": {
    "value": "var(--colors-tertiary-900)",
    "variable": "var(--colors-tertiary-900)"
  },
  "colors.tertiary.950": {
    "value": "var(--colors-tertiary-950)",
    "variable": "var(--colors-tertiary-950)"
  },
  "colors.tertiary": {
    "value": "var(--colors-tertiary)",
    "variable": "var(--colors-tertiary)"
  },
  "colors.disabled.50": {
    "value": "var(--colors-disabled-50)",
    "variable": "var(--colors-disabled-50)"
  },
  "colors.disabled.100": {
    "value": "var(--colors-disabled-100)",
    "variable": "var(--colors-disabled-100)"
  },
  "colors.disabled.200": {
    "value": "var(--colors-disabled-200)",
    "variable": "var(--colors-disabled-200)"
  },
  "colors.disabled.300": {
    "value": "var(--colors-disabled-300)",
    "variable": "var(--colors-disabled-300)"
  },
  "colors.disabled.400": {
    "value": "var(--colors-disabled-400)",
    "variable": "var(--colors-disabled-400)"
  },
  "colors.disabled.500": {
    "value": "var(--colors-disabled-500)",
    "variable": "var(--colors-disabled-500)"
  },
  "colors.disabled.600": {
    "value": "var(--colors-disabled-600)",
    "variable": "var(--colors-disabled-600)"
  },
  "colors.disabled.700": {
    "value": "var(--colors-disabled-700)",
    "variable": "var(--colors-disabled-700)"
  },
  "colors.disabled.800": {
    "value": "var(--colors-disabled-800)",
    "variable": "var(--colors-disabled-800)"
  },
  "colors.disabled.900": {
    "value": "var(--colors-disabled-900)",
    "variable": "var(--colors-disabled-900)"
  },
  "colors.disabled.950": {
    "value": "var(--colors-disabled-950)",
    "variable": "var(--colors-disabled-950)"
  },
  "colors.disabled": {
    "value": "var(--colors-disabled)",
    "variable": "var(--colors-disabled)"
  },
  "colors.neutral": {
    "value": "var(--colors-neutral)",
    "variable": "var(--colors-neutral)"
  },
  "colors.background.50": {
    "value": "var(--colors-background-50)",
    "variable": "var(--colors-background-50)"
  },
  "colors.background.100": {
    "value": "var(--colors-background-100)",
    "variable": "var(--colors-background-100)"
  },
  "colors.background.200": {
    "value": "var(--colors-background-200)",
    "variable": "var(--colors-background-200)"
  },
  "colors.background.300": {
    "value": "var(--colors-background-300)",
    "variable": "var(--colors-background-300)"
  },
  "colors.background.400": {
    "value": "var(--colors-background-400)",
    "variable": "var(--colors-background-400)"
  },
  "colors.background.500": {
    "value": "var(--colors-background-500)",
    "variable": "var(--colors-background-500)"
  },
  "colors.background.600": {
    "value": "var(--colors-background-600)",
    "variable": "var(--colors-background-600)"
  },
  "colors.background.700": {
    "value": "var(--colors-background-700)",
    "variable": "var(--colors-background-700)"
  },
  "colors.background.800": {
    "value": "var(--colors-background-800)",
    "variable": "var(--colors-background-800)"
  },
  "colors.background.900": {
    "value": "var(--colors-background-900)",
    "variable": "var(--colors-background-900)"
  },
  "colors.background.950": {
    "value": "var(--colors-background-950)",
    "variable": "var(--colors-background-950)"
  },
  "colors.background": {
    "value": "var(--colors-background)",
    "variable": "var(--colors-background)"
  },
  "shadows.glow": {
    "value": "var(--shadows-glow)",
    "variable": "var(--shadows-glow)"
  },
  "shadows.glow.error": {
    "value": "var(--shadows-glow-error)",
    "variable": "var(--shadows-glow-error)"
  },
  "spacing.-1": {
    "value": "calc(var(--spacing-1) * -1)",
    "variable": "var(--spacing-1)"
  },
  "spacing.-2": {
    "value": "calc(var(--spacing-2) * -1)",
    "variable": "var(--spacing-2)"
  },
  "spacing.-3": {
    "value": "calc(var(--spacing-3) * -1)",
    "variable": "var(--spacing-3)"
  },
  "spacing.-4": {
    "value": "calc(var(--spacing-4) * -1)",
    "variable": "var(--spacing-4)"
  },
  "spacing.-5": {
    "value": "calc(var(--spacing-5) * -1)",
    "variable": "var(--spacing-5)"
  },
  "spacing.-6": {
    "value": "calc(var(--spacing-6) * -1)",
    "variable": "var(--spacing-6)"
  },
  "spacing.-7": {
    "value": "calc(var(--spacing-7) * -1)",
    "variable": "var(--spacing-7)"
  },
  "spacing.-8": {
    "value": "calc(var(--spacing-8) * -1)",
    "variable": "var(--spacing-8)"
  },
  "spacing.-9": {
    "value": "calc(var(--spacing-9) * -1)",
    "variable": "var(--spacing-9)"
  },
  "spacing.-10": {
    "value": "calc(var(--spacing-10) * -1)",
    "variable": "var(--spacing-10)"
  },
  "spacing.-11": {
    "value": "calc(var(--spacing-11) * -1)",
    "variable": "var(--spacing-11)"
  },
  "spacing.-12": {
    "value": "calc(var(--spacing-12) * -1)",
    "variable": "var(--spacing-12)"
  },
  "spacing.-14": {
    "value": "calc(var(--spacing-14) * -1)",
    "variable": "var(--spacing-14)"
  },
  "spacing.-16": {
    "value": "calc(var(--spacing-16) * -1)",
    "variable": "var(--spacing-16)"
  },
  "spacing.-20": {
    "value": "calc(var(--spacing-20) * -1)",
    "variable": "var(--spacing-20)"
  },
  "spacing.-24": {
    "value": "calc(var(--spacing-24) * -1)",
    "variable": "var(--spacing-24)"
  },
  "spacing.-28": {
    "value": "calc(var(--spacing-28) * -1)",
    "variable": "var(--spacing-28)"
  },
  "spacing.-32": {
    "value": "calc(var(--spacing-32) * -1)",
    "variable": "var(--spacing-32)"
  },
  "spacing.-36": {
    "value": "calc(var(--spacing-36) * -1)",
    "variable": "var(--spacing-36)"
  },
  "spacing.-40": {
    "value": "calc(var(--spacing-40) * -1)",
    "variable": "var(--spacing-40)"
  },
  "spacing.-44": {
    "value": "calc(var(--spacing-44) * -1)",
    "variable": "var(--spacing-44)"
  },
  "spacing.-48": {
    "value": "calc(var(--spacing-48) * -1)",
    "variable": "var(--spacing-48)"
  },
  "spacing.-52": {
    "value": "calc(var(--spacing-52) * -1)",
    "variable": "var(--spacing-52)"
  },
  "spacing.-56": {
    "value": "calc(var(--spacing-56) * -1)",
    "variable": "var(--spacing-56)"
  },
  "spacing.-60": {
    "value": "calc(var(--spacing-60) * -1)",
    "variable": "var(--spacing-60)"
  },
  "spacing.-64": {
    "value": "calc(var(--spacing-64) * -1)",
    "variable": "var(--spacing-64)"
  },
  "spacing.-72": {
    "value": "calc(var(--spacing-72) * -1)",
    "variable": "var(--spacing-72)"
  },
  "spacing.-80": {
    "value": "calc(var(--spacing-80) * -1)",
    "variable": "var(--spacing-80)"
  },
  "spacing.-96": {
    "value": "calc(var(--spacing-96) * -1)",
    "variable": "var(--spacing-96)"
  },
  "spacing.-0.5": {
    "value": "calc(var(--spacing-0\\.5) * -1)",
    "variable": "var(--spacing-0\\.5)"
  },
  "spacing.-1.5": {
    "value": "calc(var(--spacing-1\\.5) * -1)",
    "variable": "var(--spacing-1\\.5)"
  },
  "spacing.-2.5": {
    "value": "calc(var(--spacing-2\\.5) * -1)",
    "variable": "var(--spacing-2\\.5)"
  },
  "spacing.-3.5": {
    "value": "calc(var(--spacing-3\\.5) * -1)",
    "variable": "var(--spacing-3\\.5)"
  },
  "spacing.-4.5": {
    "value": "calc(var(--spacing-4\\.5) * -1)",
    "variable": "var(--spacing-4\\.5)"
  },
  "colors.bg.canvas": {
    "value": "var(--colors-bg-canvas)",
    "variable": "var(--colors-bg-canvas)"
  },
  "colors.bg.default": {
    "value": "var(--colors-bg-default)",
    "variable": "var(--colors-bg-default)"
  },
  "colors.bg.subtle": {
    "value": "var(--colors-bg-subtle)",
    "variable": "var(--colors-bg-subtle)"
  },
  "colors.bg.muted": {
    "value": "var(--colors-bg-muted)",
    "variable": "var(--colors-bg-muted)"
  },
  "colors.bg.emphasized": {
    "value": "var(--colors-bg-emphasized)",
    "variable": "var(--colors-bg-emphasized)"
  },
  "colors.bg.disabled": {
    "value": "var(--colors-bg-disabled)",
    "variable": "var(--colors-bg-disabled)"
  },
  "colors.fg.default": {
    "value": "var(--colors-fg-default)",
    "variable": "var(--colors-fg-default)"
  },
  "colors.fg.muted": {
    "value": "var(--colors-fg-muted)",
    "variable": "var(--colors-fg-muted)"
  },
  "colors.fg.subtle": {
    "value": "var(--colors-fg-subtle)",
    "variable": "var(--colors-fg-subtle)"
  },
  "colors.fg.disabled": {
    "value": "var(--colors-fg-disabled)",
    "variable": "var(--colors-fg-disabled)"
  },
  "colors.fg.error": {
    "value": "var(--colors-fg-error)",
    "variable": "var(--colors-fg-error)"
  },
  "colors.border.default": {
    "value": "var(--colors-border-default)",
    "variable": "var(--colors-border-default)"
  },
  "colors.border.muted": {
    "value": "var(--colors-border-muted)",
    "variable": "var(--colors-border-muted)"
  },
  "colors.border.subtle": {
    "value": "var(--colors-border-subtle)",
    "variable": "var(--colors-border-subtle)"
  },
  "colors.border.disabled": {
    "value": "var(--colors-border-disabled)",
    "variable": "var(--colors-border-disabled)"
  },
  "colors.border.outline": {
    "value": "var(--colors-border-outline)",
    "variable": "var(--colors-border-outline)"
  },
  "colors.border.error": {
    "value": "var(--colors-border-error)",
    "variable": "var(--colors-border-error)"
  },
  "colors.red.1": {
    "value": "var(--colors-red-1)",
    "variable": "var(--colors-red-1)"
  },
  "colors.red.2": {
    "value": "var(--colors-red-2)",
    "variable": "var(--colors-red-2)"
  },
  "colors.red.3": {
    "value": "var(--colors-red-3)",
    "variable": "var(--colors-red-3)"
  },
  "colors.red.4": {
    "value": "var(--colors-red-4)",
    "variable": "var(--colors-red-4)"
  },
  "colors.red.5": {
    "value": "var(--colors-red-5)",
    "variable": "var(--colors-red-5)"
  },
  "colors.red.6": {
    "value": "var(--colors-red-6)",
    "variable": "var(--colors-red-6)"
  },
  "colors.red.7": {
    "value": "var(--colors-red-7)",
    "variable": "var(--colors-red-7)"
  },
  "colors.red.8": {
    "value": "var(--colors-red-8)",
    "variable": "var(--colors-red-8)"
  },
  "colors.red.9": {
    "value": "var(--colors-red-9)",
    "variable": "var(--colors-red-9)"
  },
  "colors.red.10": {
    "value": "var(--colors-red-10)",
    "variable": "var(--colors-red-10)"
  },
  "colors.red.11": {
    "value": "var(--colors-red-11)",
    "variable": "var(--colors-red-11)"
  },
  "colors.red.12": {
    "value": "var(--colors-red-12)",
    "variable": "var(--colors-red-12)"
  },
  "colors.red.a1": {
    "value": "var(--colors-red-a1)",
    "variable": "var(--colors-red-a1)"
  },
  "colors.red.a2": {
    "value": "var(--colors-red-a2)",
    "variable": "var(--colors-red-a2)"
  },
  "colors.red.a3": {
    "value": "var(--colors-red-a3)",
    "variable": "var(--colors-red-a3)"
  },
  "colors.red.a4": {
    "value": "var(--colors-red-a4)",
    "variable": "var(--colors-red-a4)"
  },
  "colors.red.a5": {
    "value": "var(--colors-red-a5)",
    "variable": "var(--colors-red-a5)"
  },
  "colors.red.a6": {
    "value": "var(--colors-red-a6)",
    "variable": "var(--colors-red-a6)"
  },
  "colors.red.a7": {
    "value": "var(--colors-red-a7)",
    "variable": "var(--colors-red-a7)"
  },
  "colors.red.a8": {
    "value": "var(--colors-red-a8)",
    "variable": "var(--colors-red-a8)"
  },
  "colors.red.a9": {
    "value": "var(--colors-red-a9)",
    "variable": "var(--colors-red-a9)"
  },
  "colors.red.a10": {
    "value": "var(--colors-red-a10)",
    "variable": "var(--colors-red-a10)"
  },
  "colors.red.a11": {
    "value": "var(--colors-red-a11)",
    "variable": "var(--colors-red-a11)"
  },
  "colors.red.a12": {
    "value": "var(--colors-red-a12)",
    "variable": "var(--colors-red-a12)"
  },
  "colors.red.default": {
    "value": "var(--colors-red-default)",
    "variable": "var(--colors-red-default)"
  },
  "colors.red.emphasized": {
    "value": "var(--colors-red-emphasized)",
    "variable": "var(--colors-red-emphasized)"
  },
  "colors.red.fg": {
    "value": "var(--colors-red-fg)",
    "variable": "var(--colors-red-fg)"
  },
  "colors.red.text": {
    "value": "var(--colors-red-text)",
    "variable": "var(--colors-red-text)"
  },
  "colors.gray.1": {
    "value": "var(--colors-gray-1)",
    "variable": "var(--colors-gray-1)"
  },
  "colors.gray.2": {
    "value": "var(--colors-gray-2)",
    "variable": "var(--colors-gray-2)"
  },
  "colors.gray.3": {
    "value": "var(--colors-gray-3)",
    "variable": "var(--colors-gray-3)"
  },
  "colors.gray.4": {
    "value": "var(--colors-gray-4)",
    "variable": "var(--colors-gray-4)"
  },
  "colors.gray.5": {
    "value": "var(--colors-gray-5)",
    "variable": "var(--colors-gray-5)"
  },
  "colors.gray.6": {
    "value": "var(--colors-gray-6)",
    "variable": "var(--colors-gray-6)"
  },
  "colors.gray.7": {
    "value": "var(--colors-gray-7)",
    "variable": "var(--colors-gray-7)"
  },
  "colors.gray.8": {
    "value": "var(--colors-gray-8)",
    "variable": "var(--colors-gray-8)"
  },
  "colors.gray.9": {
    "value": "var(--colors-gray-9)",
    "variable": "var(--colors-gray-9)"
  },
  "colors.gray.10": {
    "value": "var(--colors-gray-10)",
    "variable": "var(--colors-gray-10)"
  },
  "colors.gray.11": {
    "value": "var(--colors-gray-11)",
    "variable": "var(--colors-gray-11)"
  },
  "colors.gray.12": {
    "value": "var(--colors-gray-12)",
    "variable": "var(--colors-gray-12)"
  },
  "colors.gray.a1": {
    "value": "var(--colors-gray-a1)",
    "variable": "var(--colors-gray-a1)"
  },
  "colors.gray.a2": {
    "value": "var(--colors-gray-a2)",
    "variable": "var(--colors-gray-a2)"
  },
  "colors.gray.a3": {
    "value": "var(--colors-gray-a3)",
    "variable": "var(--colors-gray-a3)"
  },
  "colors.gray.a4": {
    "value": "var(--colors-gray-a4)",
    "variable": "var(--colors-gray-a4)"
  },
  "colors.gray.a5": {
    "value": "var(--colors-gray-a5)",
    "variable": "var(--colors-gray-a5)"
  },
  "colors.gray.a6": {
    "value": "var(--colors-gray-a6)",
    "variable": "var(--colors-gray-a6)"
  },
  "colors.gray.a7": {
    "value": "var(--colors-gray-a7)",
    "variable": "var(--colors-gray-a7)"
  },
  "colors.gray.a8": {
    "value": "var(--colors-gray-a8)",
    "variable": "var(--colors-gray-a8)"
  },
  "colors.gray.a9": {
    "value": "var(--colors-gray-a9)",
    "variable": "var(--colors-gray-a9)"
  },
  "colors.gray.a10": {
    "value": "var(--colors-gray-a10)",
    "variable": "var(--colors-gray-a10)"
  },
  "colors.gray.a11": {
    "value": "var(--colors-gray-a11)",
    "variable": "var(--colors-gray-a11)"
  },
  "colors.gray.a12": {
    "value": "var(--colors-gray-a12)",
    "variable": "var(--colors-gray-a12)"
  },
  "colors.gray.default": {
    "value": "var(--colors-gray-default)",
    "variable": "var(--colors-gray-default)"
  },
  "colors.gray.emphasized": {
    "value": "var(--colors-gray-emphasized)",
    "variable": "var(--colors-gray-emphasized)"
  },
  "colors.gray.fg": {
    "value": "var(--colors-gray-fg)",
    "variable": "var(--colors-gray-fg)"
  },
  "colors.gray.text": {
    "value": "var(--colors-gray-text)",
    "variable": "var(--colors-gray-text)"
  },
  "colors.primary.1": {
    "value": "var(--colors-primary-1)",
    "variable": "var(--colors-primary-1)"
  },
  "colors.primary.2": {
    "value": "var(--colors-primary-2)",
    "variable": "var(--colors-primary-2)"
  },
  "colors.primary.3": {
    "value": "var(--colors-primary-3)",
    "variable": "var(--colors-primary-3)"
  },
  "colors.primary.4": {
    "value": "var(--colors-primary-4)",
    "variable": "var(--colors-primary-4)"
  },
  "colors.primary.5": {
    "value": "var(--colors-primary-5)",
    "variable": "var(--colors-primary-5)"
  },
  "colors.primary.6": {
    "value": "var(--colors-primary-6)",
    "variable": "var(--colors-primary-6)"
  },
  "colors.primary.7": {
    "value": "var(--colors-primary-7)",
    "variable": "var(--colors-primary-7)"
  },
  "colors.primary.8": {
    "value": "var(--colors-primary-8)",
    "variable": "var(--colors-primary-8)"
  },
  "colors.primary.9": {
    "value": "var(--colors-primary-9)",
    "variable": "var(--colors-primary-9)"
  },
  "colors.primary.10": {
    "value": "var(--colors-primary-10)",
    "variable": "var(--colors-primary-10)"
  },
  "colors.primary.11": {
    "value": "var(--colors-primary-11)",
    "variable": "var(--colors-primary-11)"
  },
  "colors.primary.12": {
    "value": "var(--colors-primary-12)",
    "variable": "var(--colors-primary-12)"
  },
  "colors.primary.a1": {
    "value": "var(--colors-primary-a1)",
    "variable": "var(--colors-primary-a1)"
  },
  "colors.primary.a2": {
    "value": "var(--colors-primary-a2)",
    "variable": "var(--colors-primary-a2)"
  },
  "colors.primary.a3": {
    "value": "var(--colors-primary-a3)",
    "variable": "var(--colors-primary-a3)"
  },
  "colors.primary.a4": {
    "value": "var(--colors-primary-a4)",
    "variable": "var(--colors-primary-a4)"
  },
  "colors.primary.a5": {
    "value": "var(--colors-primary-a5)",
    "variable": "var(--colors-primary-a5)"
  },
  "colors.primary.a6": {
    "value": "var(--colors-primary-a6)",
    "variable": "var(--colors-primary-a6)"
  },
  "colors.primary.a7": {
    "value": "var(--colors-primary-a7)",
    "variable": "var(--colors-primary-a7)"
  },
  "colors.primary.a8": {
    "value": "var(--colors-primary-a8)",
    "variable": "var(--colors-primary-a8)"
  },
  "colors.primary.a9": {
    "value": "var(--colors-primary-a9)",
    "variable": "var(--colors-primary-a9)"
  },
  "colors.primary.a10": {
    "value": "var(--colors-primary-a10)",
    "variable": "var(--colors-primary-a10)"
  },
  "colors.primary.a11": {
    "value": "var(--colors-primary-a11)",
    "variable": "var(--colors-primary-a11)"
  },
  "colors.primary.a12": {
    "value": "var(--colors-primary-a12)",
    "variable": "var(--colors-primary-a12)"
  },
  "colors.primary.default": {
    "value": "var(--colors-primary-default)",
    "variable": "var(--colors-primary-default)"
  },
  "colors.primary.emphasized": {
    "value": "var(--colors-primary-emphasized)",
    "variable": "var(--colors-primary-emphasized)"
  },
  "colors.primary.fg": {
    "value": "var(--colors-primary-fg)",
    "variable": "var(--colors-primary-fg)"
  },
  "colors.primary.text": {
    "value": "var(--colors-primary-text)",
    "variable": "var(--colors-primary-text)"
  },
  "colors.neutral.1": {
    "value": "var(--colors-neutral-1)",
    "variable": "var(--colors-neutral-1)"
  },
  "colors.neutral.2": {
    "value": "var(--colors-neutral-2)",
    "variable": "var(--colors-neutral-2)"
  },
  "colors.neutral.3": {
    "value": "var(--colors-neutral-3)",
    "variable": "var(--colors-neutral-3)"
  },
  "colors.neutral.4": {
    "value": "var(--colors-neutral-4)",
    "variable": "var(--colors-neutral-4)"
  },
  "colors.neutral.5": {
    "value": "var(--colors-neutral-5)",
    "variable": "var(--colors-neutral-5)"
  },
  "colors.neutral.6": {
    "value": "var(--colors-neutral-6)",
    "variable": "var(--colors-neutral-6)"
  },
  "colors.neutral.7": {
    "value": "var(--colors-neutral-7)",
    "variable": "var(--colors-neutral-7)"
  },
  "colors.neutral.8": {
    "value": "var(--colors-neutral-8)",
    "variable": "var(--colors-neutral-8)"
  },
  "colors.neutral.9": {
    "value": "var(--colors-neutral-9)",
    "variable": "var(--colors-neutral-9)"
  },
  "colors.neutral.10": {
    "value": "var(--colors-neutral-10)",
    "variable": "var(--colors-neutral-10)"
  },
  "colors.neutral.11": {
    "value": "var(--colors-neutral-11)",
    "variable": "var(--colors-neutral-11)"
  },
  "colors.neutral.12": {
    "value": "var(--colors-neutral-12)",
    "variable": "var(--colors-neutral-12)"
  },
  "colors.neutral.a1": {
    "value": "var(--colors-neutral-a1)",
    "variable": "var(--colors-neutral-a1)"
  },
  "colors.neutral.a2": {
    "value": "var(--colors-neutral-a2)",
    "variable": "var(--colors-neutral-a2)"
  },
  "colors.neutral.a3": {
    "value": "var(--colors-neutral-a3)",
    "variable": "var(--colors-neutral-a3)"
  },
  "colors.neutral.a4": {
    "value": "var(--colors-neutral-a4)",
    "variable": "var(--colors-neutral-a4)"
  },
  "colors.neutral.a5": {
    "value": "var(--colors-neutral-a5)",
    "variable": "var(--colors-neutral-a5)"
  },
  "colors.neutral.a6": {
    "value": "var(--colors-neutral-a6)",
    "variable": "var(--colors-neutral-a6)"
  },
  "colors.neutral.a7": {
    "value": "var(--colors-neutral-a7)",
    "variable": "var(--colors-neutral-a7)"
  },
  "colors.neutral.a8": {
    "value": "var(--colors-neutral-a8)",
    "variable": "var(--colors-neutral-a8)"
  },
  "colors.neutral.a9": {
    "value": "var(--colors-neutral-a9)",
    "variable": "var(--colors-neutral-a9)"
  },
  "colors.neutral.a10": {
    "value": "var(--colors-neutral-a10)",
    "variable": "var(--colors-neutral-a10)"
  },
  "colors.neutral.a11": {
    "value": "var(--colors-neutral-a11)",
    "variable": "var(--colors-neutral-a11)"
  },
  "colors.neutral.a12": {
    "value": "var(--colors-neutral-a12)",
    "variable": "var(--colors-neutral-a12)"
  },
  "colors.neutral.default": {
    "value": "var(--colors-neutral-default)",
    "variable": "var(--colors-neutral-default)"
  },
  "colors.neutral.emphasized": {
    "value": "var(--colors-neutral-emphasized)",
    "variable": "var(--colors-neutral-emphasized)"
  },
  "colors.neutral.fg": {
    "value": "var(--colors-neutral-fg)",
    "variable": "var(--colors-neutral-fg)"
  },
  "colors.neutral.text": {
    "value": "var(--colors-neutral-text)",
    "variable": "var(--colors-neutral-text)"
  },
  "shadows.xs": {
    "value": "var(--shadows-xs)",
    "variable": "var(--shadows-xs)"
  },
  "shadows.sm": {
    "value": "var(--shadows-sm)",
    "variable": "var(--shadows-sm)"
  },
  "shadows.md": {
    "value": "var(--shadows-md)",
    "variable": "var(--shadows-md)"
  },
  "shadows.lg": {
    "value": "var(--shadows-lg)",
    "variable": "var(--shadows-lg)"
  },
  "shadows.xl": {
    "value": "var(--shadows-xl)",
    "variable": "var(--shadows-xl)"
  },
  "shadows.2xl": {
    "value": "var(--shadows-2xl)",
    "variable": "var(--shadows-2xl)"
  },
  "colors.warning.50": {
    "value": "var(--colors-warning-50)",
    "variable": "var(--colors-warning-50)"
  },
  "colors.warning.100": {
    "value": "var(--colors-warning-100)",
    "variable": "var(--colors-warning-100)"
  },
  "colors.warning.200": {
    "value": "var(--colors-warning-200)",
    "variable": "var(--colors-warning-200)"
  },
  "colors.warning.300": {
    "value": "var(--colors-warning-300)",
    "variable": "var(--colors-warning-300)"
  },
  "colors.warning.400": {
    "value": "var(--colors-warning-400)",
    "variable": "var(--colors-warning-400)"
  },
  "colors.warning.500": {
    "value": "var(--colors-warning-500)",
    "variable": "var(--colors-warning-500)"
  },
  "colors.warning.600": {
    "value": "var(--colors-warning-600)",
    "variable": "var(--colors-warning-600)"
  },
  "colors.warning.700": {
    "value": "var(--colors-warning-700)",
    "variable": "var(--colors-warning-700)"
  },
  "colors.warning.800": {
    "value": "var(--colors-warning-800)",
    "variable": "var(--colors-warning-800)"
  },
  "colors.warning.900": {
    "value": "var(--colors-warning-900)",
    "variable": "var(--colors-warning-900)"
  },
  "colors.warning.950": {
    "value": "var(--colors-warning-950)",
    "variable": "var(--colors-warning-950)"
  },
  "colors.warning": {
    "value": "var(--colors-warning)",
    "variable": "var(--colors-warning)"
  },
  "colors.colorPalette": {
    "value": "var(--colors-color-palette)",
    "variable": "var(--colors-color-palette)"
  },
  "colors.colorPalette.a1": {
    "value": "var(--colors-color-palette-a1)",
    "variable": "var(--colors-color-palette-a1)"
  },
  "colors.colorPalette.a2": {
    "value": "var(--colors-color-palette-a2)",
    "variable": "var(--colors-color-palette-a2)"
  },
  "colors.colorPalette.a3": {
    "value": "var(--colors-color-palette-a3)",
    "variable": "var(--colors-color-palette-a3)"
  },
  "colors.colorPalette.a4": {
    "value": "var(--colors-color-palette-a4)",
    "variable": "var(--colors-color-palette-a4)"
  },
  "colors.colorPalette.a5": {
    "value": "var(--colors-color-palette-a5)",
    "variable": "var(--colors-color-palette-a5)"
  },
  "colors.colorPalette.a6": {
    "value": "var(--colors-color-palette-a6)",
    "variable": "var(--colors-color-palette-a6)"
  },
  "colors.colorPalette.a7": {
    "value": "var(--colors-color-palette-a7)",
    "variable": "var(--colors-color-palette-a7)"
  },
  "colors.colorPalette.a8": {
    "value": "var(--colors-color-palette-a8)",
    "variable": "var(--colors-color-palette-a8)"
  },
  "colors.colorPalette.a9": {
    "value": "var(--colors-color-palette-a9)",
    "variable": "var(--colors-color-palette-a9)"
  },
  "colors.colorPalette.a10": {
    "value": "var(--colors-color-palette-a10)",
    "variable": "var(--colors-color-palette-a10)"
  },
  "colors.colorPalette.a11": {
    "value": "var(--colors-color-palette-a11)",
    "variable": "var(--colors-color-palette-a11)"
  },
  "colors.colorPalette.a12": {
    "value": "var(--colors-color-palette-a12)",
    "variable": "var(--colors-color-palette-a12)"
  },
  "colors.colorPalette.light.1": {
    "value": "var(--colors-color-palette-light-1)",
    "variable": "var(--colors-color-palette-light-1)"
  },
  "colors.colorPalette.1": {
    "value": "var(--colors-color-palette-1)",
    "variable": "var(--colors-color-palette-1)"
  },
  "colors.colorPalette.light.2": {
    "value": "var(--colors-color-palette-light-2)",
    "variable": "var(--colors-color-palette-light-2)"
  },
  "colors.colorPalette.2": {
    "value": "var(--colors-color-palette-2)",
    "variable": "var(--colors-color-palette-2)"
  },
  "colors.colorPalette.light.3": {
    "value": "var(--colors-color-palette-light-3)",
    "variable": "var(--colors-color-palette-light-3)"
  },
  "colors.colorPalette.3": {
    "value": "var(--colors-color-palette-3)",
    "variable": "var(--colors-color-palette-3)"
  },
  "colors.colorPalette.light.4": {
    "value": "var(--colors-color-palette-light-4)",
    "variable": "var(--colors-color-palette-light-4)"
  },
  "colors.colorPalette.4": {
    "value": "var(--colors-color-palette-4)",
    "variable": "var(--colors-color-palette-4)"
  },
  "colors.colorPalette.light.5": {
    "value": "var(--colors-color-palette-light-5)",
    "variable": "var(--colors-color-palette-light-5)"
  },
  "colors.colorPalette.5": {
    "value": "var(--colors-color-palette-5)",
    "variable": "var(--colors-color-palette-5)"
  },
  "colors.colorPalette.light.6": {
    "value": "var(--colors-color-palette-light-6)",
    "variable": "var(--colors-color-palette-light-6)"
  },
  "colors.colorPalette.6": {
    "value": "var(--colors-color-palette-6)",
    "variable": "var(--colors-color-palette-6)"
  },
  "colors.colorPalette.light.7": {
    "value": "var(--colors-color-palette-light-7)",
    "variable": "var(--colors-color-palette-light-7)"
  },
  "colors.colorPalette.7": {
    "value": "var(--colors-color-palette-7)",
    "variable": "var(--colors-color-palette-7)"
  },
  "colors.colorPalette.light.8": {
    "value": "var(--colors-color-palette-light-8)",
    "variable": "var(--colors-color-palette-light-8)"
  },
  "colors.colorPalette.8": {
    "value": "var(--colors-color-palette-8)",
    "variable": "var(--colors-color-palette-8)"
  },
  "colors.colorPalette.light.9": {
    "value": "var(--colors-color-palette-light-9)",
    "variable": "var(--colors-color-palette-light-9)"
  },
  "colors.colorPalette.9": {
    "value": "var(--colors-color-palette-9)",
    "variable": "var(--colors-color-palette-9)"
  },
  "colors.colorPalette.light.10": {
    "value": "var(--colors-color-palette-light-10)",
    "variable": "var(--colors-color-palette-light-10)"
  },
  "colors.colorPalette.10": {
    "value": "var(--colors-color-palette-10)",
    "variable": "var(--colors-color-palette-10)"
  },
  "colors.colorPalette.light.11": {
    "value": "var(--colors-color-palette-light-11)",
    "variable": "var(--colors-color-palette-light-11)"
  },
  "colors.colorPalette.11": {
    "value": "var(--colors-color-palette-11)",
    "variable": "var(--colors-color-palette-11)"
  },
  "colors.colorPalette.light.12": {
    "value": "var(--colors-color-palette-light-12)",
    "variable": "var(--colors-color-palette-light-12)"
  },
  "colors.colorPalette.12": {
    "value": "var(--colors-color-palette-12)",
    "variable": "var(--colors-color-palette-12)"
  },
  "colors.colorPalette.light.a1": {
    "value": "var(--colors-color-palette-light-a1)",
    "variable": "var(--colors-color-palette-light-a1)"
  },
  "colors.colorPalette.light.a2": {
    "value": "var(--colors-color-palette-light-a2)",
    "variable": "var(--colors-color-palette-light-a2)"
  },
  "colors.colorPalette.light.a3": {
    "value": "var(--colors-color-palette-light-a3)",
    "variable": "var(--colors-color-palette-light-a3)"
  },
  "colors.colorPalette.light.a4": {
    "value": "var(--colors-color-palette-light-a4)",
    "variable": "var(--colors-color-palette-light-a4)"
  },
  "colors.colorPalette.light.a5": {
    "value": "var(--colors-color-palette-light-a5)",
    "variable": "var(--colors-color-palette-light-a5)"
  },
  "colors.colorPalette.light.a6": {
    "value": "var(--colors-color-palette-light-a6)",
    "variable": "var(--colors-color-palette-light-a6)"
  },
  "colors.colorPalette.light.a7": {
    "value": "var(--colors-color-palette-light-a7)",
    "variable": "var(--colors-color-palette-light-a7)"
  },
  "colors.colorPalette.light.a8": {
    "value": "var(--colors-color-palette-light-a8)",
    "variable": "var(--colors-color-palette-light-a8)"
  },
  "colors.colorPalette.light.a9": {
    "value": "var(--colors-color-palette-light-a9)",
    "variable": "var(--colors-color-palette-light-a9)"
  },
  "colors.colorPalette.light.a10": {
    "value": "var(--colors-color-palette-light-a10)",
    "variable": "var(--colors-color-palette-light-a10)"
  },
  "colors.colorPalette.light.a11": {
    "value": "var(--colors-color-palette-light-a11)",
    "variable": "var(--colors-color-palette-light-a11)"
  },
  "colors.colorPalette.light.a12": {
    "value": "var(--colors-color-palette-light-a12)",
    "variable": "var(--colors-color-palette-light-a12)"
  },
  "colors.colorPalette.dark.1": {
    "value": "var(--colors-color-palette-dark-1)",
    "variable": "var(--colors-color-palette-dark-1)"
  },
  "colors.colorPalette.dark.2": {
    "value": "var(--colors-color-palette-dark-2)",
    "variable": "var(--colors-color-palette-dark-2)"
  },
  "colors.colorPalette.dark.3": {
    "value": "var(--colors-color-palette-dark-3)",
    "variable": "var(--colors-color-palette-dark-3)"
  },
  "colors.colorPalette.dark.4": {
    "value": "var(--colors-color-palette-dark-4)",
    "variable": "var(--colors-color-palette-dark-4)"
  },
  "colors.colorPalette.dark.5": {
    "value": "var(--colors-color-palette-dark-5)",
    "variable": "var(--colors-color-palette-dark-5)"
  },
  "colors.colorPalette.dark.6": {
    "value": "var(--colors-color-palette-dark-6)",
    "variable": "var(--colors-color-palette-dark-6)"
  },
  "colors.colorPalette.dark.7": {
    "value": "var(--colors-color-palette-dark-7)",
    "variable": "var(--colors-color-palette-dark-7)"
  },
  "colors.colorPalette.dark.8": {
    "value": "var(--colors-color-palette-dark-8)",
    "variable": "var(--colors-color-palette-dark-8)"
  },
  "colors.colorPalette.dark.9": {
    "value": "var(--colors-color-palette-dark-9)",
    "variable": "var(--colors-color-palette-dark-9)"
  },
  "colors.colorPalette.dark.10": {
    "value": "var(--colors-color-palette-dark-10)",
    "variable": "var(--colors-color-palette-dark-10)"
  },
  "colors.colorPalette.dark.11": {
    "value": "var(--colors-color-palette-dark-11)",
    "variable": "var(--colors-color-palette-dark-11)"
  },
  "colors.colorPalette.dark.12": {
    "value": "var(--colors-color-palette-dark-12)",
    "variable": "var(--colors-color-palette-dark-12)"
  },
  "colors.colorPalette.dark.a1": {
    "value": "var(--colors-color-palette-dark-a1)",
    "variable": "var(--colors-color-palette-dark-a1)"
  },
  "colors.colorPalette.dark.a2": {
    "value": "var(--colors-color-palette-dark-a2)",
    "variable": "var(--colors-color-palette-dark-a2)"
  },
  "colors.colorPalette.dark.a3": {
    "value": "var(--colors-color-palette-dark-a3)",
    "variable": "var(--colors-color-palette-dark-a3)"
  },
  "colors.colorPalette.dark.a4": {
    "value": "var(--colors-color-palette-dark-a4)",
    "variable": "var(--colors-color-palette-dark-a4)"
  },
  "colors.colorPalette.dark.a5": {
    "value": "var(--colors-color-palette-dark-a5)",
    "variable": "var(--colors-color-palette-dark-a5)"
  },
  "colors.colorPalette.dark.a6": {
    "value": "var(--colors-color-palette-dark-a6)",
    "variable": "var(--colors-color-palette-dark-a6)"
  },
  "colors.colorPalette.dark.a7": {
    "value": "var(--colors-color-palette-dark-a7)",
    "variable": "var(--colors-color-palette-dark-a7)"
  },
  "colors.colorPalette.dark.a8": {
    "value": "var(--colors-color-palette-dark-a8)",
    "variable": "var(--colors-color-palette-dark-a8)"
  },
  "colors.colorPalette.dark.a9": {
    "value": "var(--colors-color-palette-dark-a9)",
    "variable": "var(--colors-color-palette-dark-a9)"
  },
  "colors.colorPalette.dark.a10": {
    "value": "var(--colors-color-palette-dark-a10)",
    "variable": "var(--colors-color-palette-dark-a10)"
  },
  "colors.colorPalette.dark.a11": {
    "value": "var(--colors-color-palette-dark-a11)",
    "variable": "var(--colors-color-palette-dark-a11)"
  },
  "colors.colorPalette.dark.a12": {
    "value": "var(--colors-color-palette-dark-a12)",
    "variable": "var(--colors-color-palette-dark-a12)"
  },
  "colors.colorPalette.50": {
    "value": "var(--colors-color-palette-50)",
    "variable": "var(--colors-color-palette-50)"
  },
  "colors.colorPalette.100": {
    "value": "var(--colors-color-palette-100)",
    "variable": "var(--colors-color-palette-100)"
  },
  "colors.colorPalette.200": {
    "value": "var(--colors-color-palette-200)",
    "variable": "var(--colors-color-palette-200)"
  },
  "colors.colorPalette.300": {
    "value": "var(--colors-color-palette-300)",
    "variable": "var(--colors-color-palette-300)"
  },
  "colors.colorPalette.400": {
    "value": "var(--colors-color-palette-400)",
    "variable": "var(--colors-color-palette-400)"
  },
  "colors.colorPalette.500": {
    "value": "var(--colors-color-palette-500)",
    "variable": "var(--colors-color-palette-500)"
  },
  "colors.colorPalette.600": {
    "value": "var(--colors-color-palette-600)",
    "variable": "var(--colors-color-palette-600)"
  },
  "colors.colorPalette.700": {
    "value": "var(--colors-color-palette-700)",
    "variable": "var(--colors-color-palette-700)"
  },
  "colors.colorPalette.800": {
    "value": "var(--colors-color-palette-800)",
    "variable": "var(--colors-color-palette-800)"
  },
  "colors.colorPalette.900": {
    "value": "var(--colors-color-palette-900)",
    "variable": "var(--colors-color-palette-900)"
  },
  "colors.colorPalette.950": {
    "value": "var(--colors-color-palette-950)",
    "variable": "var(--colors-color-palette-950)"
  },
  "colors.colorPalette.canvas": {
    "value": "var(--colors-color-palette-canvas)",
    "variable": "var(--colors-color-palette-canvas)"
  },
  "colors.colorPalette.default": {
    "value": "var(--colors-color-palette-default)",
    "variable": "var(--colors-color-palette-default)"
  },
  "colors.colorPalette.subtle": {
    "value": "var(--colors-color-palette-subtle)",
    "variable": "var(--colors-color-palette-subtle)"
  },
  "colors.colorPalette.muted": {
    "value": "var(--colors-color-palette-muted)",
    "variable": "var(--colors-color-palette-muted)"
  },
  "colors.colorPalette.emphasized": {
    "value": "var(--colors-color-palette-emphasized)",
    "variable": "var(--colors-color-palette-emphasized)"
  },
  "colors.colorPalette.disabled": {
    "value": "var(--colors-color-palette-disabled)",
    "variable": "var(--colors-color-palette-disabled)"
  },
  "colors.colorPalette.error": {
    "value": "var(--colors-color-palette-error)",
    "variable": "var(--colors-color-palette-error)"
  },
  "colors.colorPalette.outline": {
    "value": "var(--colors-color-palette-outline)",
    "variable": "var(--colors-color-palette-outline)"
  },
  "colors.colorPalette.fg": {
    "value": "var(--colors-color-palette-fg)",
    "variable": "var(--colors-color-palette-fg)"
  },
  "colors.colorPalette.text": {
    "value": "var(--colors-color-palette-text)",
    "variable": "var(--colors-color-palette-text)"
  }
}

export function token(path, fallback) {
  return tokens[path]?.value || fallback
}

function tokenVar(path, fallback) {
  return tokens[path]?.variable || fallback
}

token.var = tokenVar